import React, { Component } from "react";
import { MDBBtn, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBContainer, MDBRow, MDBCol, MDBIcon, MDBModal, toast, MDBTabPane, MDBTabContent, MDBNav, MDBNavItem, MDBNavLink, MDBInput, MDBDropdown, MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem } from "mdbreact";
import axios from "../../../../axios";
import { DateInput } from "semantic-ui-calendar-react";
import { withTranslation } from "react-i18next";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import $ from "jquery";
import MessagesData from "../../../../components/VenueMgmt/Messages/Datatables/MessagesData";
import Bandwidth from "../../../../components/VenueMgmt/Bandwidth/Bandwidth";
import SubscriberKeypoolsData from "../../../../components/NetworkMgmt/Subscribers/Datatables/SubscriberKeypoolsDataMUI";
import SubscriberKeypoolsDataAllPasswords from "../../../../components/NetworkMgmt/Subscribers/Datatables/SubscriberKeypoolsDataAllPasswordsMUI";
import SubscriberTransactionsData from "../../../../components/NetworkMgmt/Subscribers/Datatables/SubscriberTransactionsData";
import AddKey from "../../../../components/NetworkMgmt/Forms/AddKey/AddKey";
import ManageDevicesData from "../../../../components/SubscriberMgmt/ManageDevices/Datatables/ManageDevicesDataMUI";
import DeviceDetails from "../../../../components/SubscriberMgmt/DeviceInformation/DeviceDetails";
import parse from "html-react-parser";
import SelectSearch, { fuzzySearch } from "react-select-search";
import countryInfo from "country-locale-map";
import getSymbolFromCurrency from "currency-symbol-map";
import _ from "lodash";
import brandsData from "../../../../brands/common/brands.json";
import JSONPretty from "react-json-pretty";

import LogViewer from "../../../NetworkMgmt/Logs/LogViewer";
import PSKValidator from "../../../../components/NetworkMgmt/Support/PSKValidator";
import PasswordConditions from "../../../../components/SubscriberMgmt/PasswordValidator/PasswordConditions";
import LinearProgress from '@mui/material/LinearProgress';
class ModifyResident extends Component {
 constructor(props) {
  super(props);
  this.handleDayChange = this.handleDayChange.bind(this);
  this.handleDayChangeEnd = this.handleDayChangeEnd.bind(this);
  this.toggleCheckboxValueSMS = this.toggleCheckboxValueSMS.bind(this);
  this.state = {
   firstName: this.props.firstName,
   lastName: this.props.lastName,
   email: this.props.email,
   originalEmail: this.props.email,
   phoneNumber: this.props.phoneNumber,
   originalPhoneNumber: this.props.phoneNumber,
   phoneNumberUpdated: false,
   selectedLanguage: this.props.language,
   selectedBuilding: this.props.building,
   selectedFloor: this.props.floor,
   floor: this.props.floor,
   building: this.props.building,
   receivetext: this.props.receivetext,
   receivephone: this.props.receivephone,
   dateStart:
    this.props.startDate !== null
     ? new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
     }).format(new Date(this.props.startDate))
     : "",
   oldDateStart: this.props.startDate,
   dateEnd:
    this.props.endDate !== ""
     ? new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
     }).format(new Date(this.props.endDate))
     : undefined,
   oldDateEnd:
    this.props.endDate !== ""
     ? new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
     }).format(new Date(this.props.endDate))
     : undefined,
   unitID: this.props.unitID,
   unitID_internal: this.props.unitID_internal,
   recentResidents: this.props.recentResidents,
   venueID: this.props.venueID,
   loading: false,
   loadingDelete: false,
   loadingMessages: true,
   ssid: this.props.SSID,
   activeItem: "1",
   activeItemRefund: "1",
   selectedServicePlan: this.props.servicePlan,
   loadingResend: false,
   availablePlans: this.props.availablePlans,
   vlan: this.props.vlan,
   status: this.props.status,
   languageOptions: [
    { value: "en-us", name: "English" },
    { value: "es-xl", name: "Spanish" },
   ],
   managedBySSO: false,
   subscriberManagedviaSSO: this.props.subscriberManagedviaSSO,
   PMS: this.props.PMS,
   paymentFailed: this.props.paymentFailed,
   currentServicePlanID: undefined,
   StripeClientSecret: this.props.StripeClientSecret,
   stripeClientParentSecret: this.props.stripeClientParentSecret,
   other: false,
   reason: [],
   radio: [],
   subscriberToken: this.props.subscriberToken,
   modalMoveVenue: false,
   modalEmailChangeConfirm: false,
   selectedDestinationVenue: "",
   selectedDestinationUnit: "",
   destinationVenueUnits: [],
   destinationVenueServicePlans: [],
   loadingMoveVenue: false,
   venues: [],
   RealPageUnitID: this.props.RealPageUnitID,
   modalRefund: false,
   modalValidationRequirements: false,
   modalPhoneNumberUpdateRequired: false,
   modalGenerateWifiHandout: false,
   continueToSMSAfterSave: false,
   validationErrors: [],
   isModifyingSubscription: false,
   currencyCode: countryInfo.getCurrencyByAlpha3(this.props.country),
   subscriptionDiscount: -Math.abs(this.props.subscriptionDiscount),
   venuePriceAdjustment: getSymbolFromCurrency(countryInfo.getCurrencyByAlpha3(this.props.country)) + (-Math.abs(this.props.venueDiscount)).toFixed(2),
   venuePriceAdjustmentNumber: this.props.venueDiscount,
   contactpref_sms: this.props.contactpref_sms,
   contactpref_email: this.props.contactpref_email,
   dateAdded: this.props.dateAdded,
   selectedServicePlanPrice: this.props.selectedServicePlanPrice,
   selectedServicePlanPriceNumber: (this.props.selectedServicePlanPrice / 100).toFixed(2),
   setupIntentID: this.props.setupIntentID,
   refundAmount: 0,
   transactions: [],
   subcriberWifiPassword: ".",
   password: ".",
   dot: true,
   passwordInvalid: false,
   count: 0,
   specialChar: false,
   submittingPSKReset: false,
   invalidPhone: null,
   isInitialLoading: true,
   loadingStates: {
    venueDetails: false,
    messages: false,
    subscriberKeys: false,
    transactions: false,
    logs: false
   },
   loadingProgress: 0,
   continueToSMS: false,
   subscriberLog: undefined,
   invalidDateStart: null,
   invalidDateEnd: null
  };
  this.handleEditorChange = this.handleEditorChange.bind(this);
 }
 // Helper method to safely create Date objects and avoid "selectable[0].position" errors
 safeDate = (dateValue) => {
  if (!dateValue || dateValue === "" || dateValue === null || dateValue === undefined) {
   return null;
  }
  const date = new Date(dateValue);
  return isNaN(date.getTime()) ? null : date;
 };
 componentDidMount() {
  // Set initial loading state
  this.setState({ isInitialLoading: true, loadingProgress: 0 });
  // Start loading venue details
  this.updateLoadingState('venueDetails', true);
  this.getVenueDetails(this.props.venueID);
  // Start loading messages
  this.updateLoadingState('messages', true);
  this.getMessages(this.props.venueID);
  // Start loading subscriber keys
  this.updateLoadingState('subscriberKeys', true);
  this.getSubscriberKeys();
  // Start loading transactions
  this.updateLoadingState('transactions', true);
  this.getTransactions();
  // Start loading logs
  this.updateLoadingState('logs', true);
  this.getLogs();
  // Load current subscription details (used to surface degraded service plan)
  this.getSubscriptions();
 }
 componentDidUpdate(prevProps) {
  // Reset loading state when parent component's loading prop changes from true to false
  if (prevProps.loading === true && this.props.loading === false && this.state.isModifyingSubscription) {
   this.setState({ 
    isModifyingSubscription: false,
    originalEmail: this.state.email // Update original email after successful save
   });
   // Only show SMS confirmation modal if this was specifically requested from SMS flow
   // and not from a regular form submission
   if (this.state.continueToSMSAfterSave) {
    // Reset the flag and show SMS confirmation modal
    this.setState({
     continueToSMSAfterSave: false,
     phoneNumberUpdated: false, // Reset since we just saved
     originalPhoneNumber: this.state.phoneNumber // Update the original phone number
    });
    // Show SMS confirmation modal only if we're continuing from SMS flow
    this.toggleResendActivationSMSConfirm();
   }
  }
 }
 updateLoadingState = (loadingKey, isComplete = false) => {
  this.setState(prevState => {
   const newLoadingStates = {
    ...prevState.loadingStates,
    [loadingKey]: isComplete
   };
   // Calculate progress (number of completed tasks / total tasks * 100)
   const completedTasks = Object.values(newLoadingStates).filter(Boolean).length;
   const totalTasks = Object.keys(newLoadingStates).length;
   const progress = (completedTasks / totalTasks) * 100;
   // Check if all loading is complete
   const allComplete = completedTasks === totalTasks;
   return {
    loadingStates: newLoadingStates,
    loadingProgress: progress,
    isInitialLoading: !allComplete
   };
  });
 };
 // Prevent keyboard input on date fields - only allow calendar selection
 preventDateKeyboardInput = (e) => {
  // Allow tab for accessibility
  if (e.key === 'Tab') {
   return true;
  }
  // Prevent all other keyboard input
  e.preventDefault();
  return false;
 };
 validateEmail = (emailEntered) => {
  this.setState({ loading: true });
  let email = emailEntered.trim();
  let body = {
   AccessToken: sessionStorage.getItem("AccessToken"),
   IdToken: sessionStorage.getItem("IdToken"),
   EmailAddress: email,
   VenueID: this.props.venueID,
  };
  axios
   .post("/venuemgmtconsole/subscribers/validateEmailAddress", body, {
    headers: {},
   })
   .then((response) => {
    this.setState({
     firstName: response.data.GivenName,
     lastName: response.data.FamilyName,
     phoneNumber: response.data["PhoneNumber.E164"],
     originalPhoneNumber: response.data["PhoneNumber.E164"],
     phoneNumberUpdated: false,
     selectedLanguage: response.data.locale,
     invalidPhone: undefined,
    });
    this.setState({ loading: false });
   })
   .catch((error) => {
    this.setState({ error: true });
    this.setState({ loading: false });
   });
 };
 getVenueDetails = (index) => {
  sessionStorage.setItem("venueIDSubscriber", index);
  let body = {
   AccessToken: sessionStorage.getItem("AccessToken"),
   IdToken: sessionStorage.getItem("IdToken"),
   VenueID: index,
   UserTimeZone: new Date().getTimezoneOffset(),
  };
  this.setState({
   unitData: undefined,
   expiringData: undefined,
   searchData: undefined,
   value: "",
  });
  axios
   .post("/venuemgmtconsole/venues/listVenueDetails", body, {
    headers: {},
   })
   .then((response) => {
    var sortedKeys = _(response.data[index]["Keypools"])
     .map(function (v, k) {
      // insert the key into the object
      return _.merge({}, v, { key: k });
     })
     .sortBy("DisplayOrder") // sort by name
     .value();
    this.setState({
     unitData: response.data[index]["Units-Building-Floor-List-Subscribers"],
     venueServicePlans: response.data[index]["AvailableServicePlans"],
     availablePlans: response.data[index]["AvailableServicePlans"],
     keyPoolList: sortedKeys,
     venueName: response.data[index]["VenueName"],
     vlan: response.data[index]["vlan"],
     nasID: response.data[index]?.NetworkConfiguration?.["NAS-Identifier"],
    });
    let units = Object.keys(response.data[index]["Units-Building-Floor-List-Subscribers"]);
    let buildings = [];
    let objUnits = {};
    for (let i = 0; i < units.length; i++) {
     buildings.push(Object.keys(response.data[index]["Units-Building-Floor-List-Subscribers"][units[i]]));
     for (let j = 0; j < buildings[i].length; j++) {
      let floor = Object.keys(response.data[index]["Units-Building-Floor-List-Subscribers"][units[i]][buildings[i][j]]);
      for (let k = 0; k < floor.length; k++) {
       const unitData = response.data[index]["Units-Building-Floor-List-Subscribers"][units[i]][buildings[i][j]][floor[k]];
       const subscriptions = unitData["Subscriptions"];
       const subscriptionKeys = Object.keys(subscriptions);
       const hasActiveSubscription = subscriptionKeys.length > 0;
       let subscriptionExpired = false;
       if (hasActiveSubscription) {
        // Check if the subscription end date is before today
        const endDate = new Date(subscriptions[subscriptionKeys[0]]["EndDateTimeUTC.ISO8601"]);
        const today = new Date();
        subscriptionExpired = endDate < today;
       }
       // Skip TEMP units unless it's the current subscriber's unit
       const isCurrentSubscriberUnit = unitData["UnitID_internal"] === this.state.unitID_internal ||
                                        unitData["UnitID_internal"] === sessionStorage.getItem("unitID_internalSubscriber");
       const isTempUnit = units[i].includes("TEMP");
       
       if (
        // unitData["PrimaryUnitID_internal"] === "" &&
        ((unitData["allowOverlappingSubscriptionWiredUnit"] === false &&
         (!hasActiveSubscription || subscriptionExpired)) ||
         unitData["allowOverlappingSubscriptionWiredUnit"] === true ||
         isCurrentSubscriberUnit) &&
        (!isTempUnit || isCurrentSubscriberUnit)
       ) {
        objUnits[i] = response.data[index]["Units-Building-Floor-List-Subscribers"][units[i]][buildings[i]];
       }
      }
     }
    }
    let optionTemplateUnits = [];
    Object.keys(objUnits).map((oneKey, i) => {
     optionTemplateUnits.push({
      value: units[oneKey],
      name: units[oneKey],
     });
     return true;
    });
    this.setState({
     selectedUnit: this.state.selectedUnit,
     optionTemplateBuilding: [],
     // selectedBuilding: undefined,
     // selectedFloor: undefined
    });
    let optionTemplateBuilding = [];
    this.setState({
     optionTemplateBuilding: [],
    });
    Object.keys(response.data[index]["Units-Building-Floor-List-Subscribers"][this.state.unitID]).map((oneKey, i) => {
     if (oneKey === "DEFAULT") {
      optionTemplateBuilding.push({
       value: oneKey,
       name: oneKey,
      });
     } else {
      optionTemplateBuilding.push({
       value: oneKey,
       name: oneKey,
      });
     }
     return true;
    });
    this.setState({
     optionTemplateBuilding: optionTemplateBuilding,
    });
    let optionTemplateFloor = [];
    Object.keys(response.data[index]["Units-Building-Floor-List-Subscribers"][this.state.unitID][this.state.building]).map((oneKey, i) => {
     if (oneKey === "DEFAULT") {
      optionTemplateFloor.push({
       value: oneKey,
       name: oneKey,
      });
     } else {
      optionTemplateFloor.push({
       value: oneKey,
       name: oneKey,
      });
     }
     return true;
    });
    this.setState({
     optionTemplateFloor: optionTemplateFloor,
    });
    let optionTemplateServicePlan = [];
    let currentBillingCycleRecurrance;
    let currentBillingCycleHours;
    Object.keys(response.data[index]["AvailableServicePlans"]).map((oneKey, i) => {
     if (this.props.servicePlanID === response.data[index]["AvailableServicePlans"][oneKey]["ServicePlanID"]) {
      currentBillingCycleRecurrance = response.data[index]["AvailableServicePlans"][oneKey]["BillingCycleRecurrence"];
      currentBillingCycleHours = response.data[index]["AvailableServicePlans"][oneKey]["BillingCycleHours"];
     }
     return true;
    });
    Object.keys(response.data[index]["AvailableServicePlans"]).map((oneKey, i) => {
     if (this.props.servicePlanID === response.data[index]["AvailableServicePlans"][oneKey]["ServicePlanID"]) {
      this.setState({
       selectedServicePlanIndex: oneKey,
       selectedServicePlanID: this.props.servicePlanID,
       netBillingPrice: ((this.props.selectedServicePlanPrice + (this.props.venueDiscount * 100) + this.state.subscriptionDiscount * 100) / 100).toFixed(2),
      });
      currentBillingCycleRecurrance = response.data[index]["AvailableServicePlans"][oneKey]["BillingCycleRecurrence"];
     }
     if (currentBillingCycleRecurrance === response.data[index]["AvailableServicePlans"][oneKey]["BillingCycleRecurrence"] && currentBillingCycleHours === response.data[index]["AvailableServicePlans"][oneKey]["BillingCycleHours"]) {
      optionTemplateServicePlan.push({
       value: oneKey,
       name: response.data[index]["AvailableServicePlans"][oneKey]["ServicePlanName"],
      });
     }
     return true;
    });
    if (optionTemplateServicePlan.length === 0) {
     Object.keys(response.data[index]["AvailableServicePlans"]).map(
      // eslint-disable-next-line array-callback-return
      (oneKey, i) => {
       optionTemplateServicePlan.push({
        value: oneKey,
        name: response.data[index]["AvailableServicePlans"][oneKey]["ServicePlanName"],
       });
      }
     );
    }
    this.setState({
     optionTemplateUnits: optionTemplateUnits,
     optionTemplateServicePlan: optionTemplateServicePlan,
    });
    // Mark venue details loading as complete
    this.updateLoadingState('venueDetails', true);
   })
   .catch((error) => {
    this.setState({ error: true });
    // Mark venue details loading as complete even on error
    this.updateLoadingState('venueDetails', true);
   });
 };
 handleSelectChangeUnit = (value) => {
  this.setState({
   selectedUnit: value,
   optionTemplateBuilding: [],
   selectedBuilding: undefined,
   selectedFloor: undefined,
   building: undefined,
   floor: undefined,
   updatedUnit: true,
   unitID: value,
  });
  let optionTemplateBuilding = [];
  this.setState({
   optionTemplateBuilding: [],
  });
  Object.keys(this.state.unitData[value]).map((oneKey, i) => {
   if (oneKey === "DEFAULT") {
    optionTemplateBuilding.push({ value: oneKey, name: oneKey });
   } else {
    optionTemplateBuilding.push({ value: oneKey, name: oneKey });
   }
   return true;
  });
  this.setState({
   optionTemplateBuilding: optionTemplateBuilding,
  });
 };
 handleSelectChangeBuilding = (value) => {
  if (value !== null) {
   this.setState({
    selectedBuilding: value,
   });
   let optionTemplateFloor = [];
   Object.keys(this.state.unitData[this.state.selectedUnit][value]).map((oneKey, i) => {
    if (oneKey === "DEFAULT") {
     optionTemplateFloor.push({ value: oneKey, name: oneKey });
    } else {
     optionTemplateFloor.push({ value: oneKey, name: oneKey });
    }
    return true;
   });
   this.setState({
    optionTemplateFloor: optionTemplateFloor,
   });
  }
 };
 handleSelectChangeFloor = (value) => {
  if (value !== null) {
   this.setState({ selectedFloor: value });
   this.setState({
    unitID_internal: this.state.unitData[this.state.selectedUnit][this.state.selectedBuilding][value]["UnitID_internal"],
   });
  }
 };
 getMessages = (index) => {
  this.setState({ messages: undefined });
  let body = {
   AccessToken: sessionStorage.getItem("AccessToken"),
   IdToken: sessionStorage.getItem("IdToken"),
   VenueID: index,
   EmailAddress: this.state.email,
  };
  axios
   .post("/venuemgmtconsole/subscribers/listMessages", body, {
    headers: {},
   })
   .then((response) => {
    this.setState({
     messages: response.data.messages,
     loadingMessages: false,
    });
    // Mark messages loading as complete
    this.updateLoadingState('messages', true);
   })
   .catch((error) => {
    this.setState({
     error: true,
    });
    // Mark messages loading as complete even on error
    this.updateLoadingState('messages', true);
   });
  if (this.state.messages !== undefined) {
   this.setState({ loadingMessages: false });
  }
 };
 getSubscriberKeys = () => {
  this.setState({ subscriberKeys: undefined });
  if (window.location.pathname === "/networkdashboard") {
   let body = {
    AccessToken: sessionStorage.getItem("AccessToken"),
    IdToken: sessionStorage.getItem("IdToken"),
    EmailAddress: this.state.email,
   };
   axios
    .post("/networkoperatorconsole/subscribers/listSubscriberKeys", body, {
     headers: {},
    })
    .then((response) => {
     this.setState({
      subscriberKeys: response.data.KeysInKeyPools,
      subscriberToken: response.data.SubscriberToken,
      loadingKeys: false,
      managedBySSO: response.data.SubscriberManagedviaSSO,
      cognitoStatus: response.data.CognitoStatus,
      status: response.data.Status,
      emailVerified: response.data.email_verified,
      phoneVerified: response.data.phone_number_verified,
      externalSubscriberID: response.data.externalSubscriberID,
      stripeCustomerID: response.data.StripeCustomerID,
      subscriberManagedviaSSO: response.data.SubscriberManagedviaSSO,
      contactpref_sms: response.data.contactpref_sms,
      contactpref_email: response.data.contactpref_email,
      dateAdded: response.data["dateAddedUTC.ISO8601"]
     });
     this.getDevices(response.data.SubscriberToken);
     // Mark subscriber keys loading as complete
     this.updateLoadingState('subscriberKeys', true);
    })
    .catch((error) => {
     this.setState({
      error: true,
     });
     // Mark subscriber keys loading as complete even on error
     this.updateLoadingState('subscriberKeys', true);
    });
  } else {
   // If not network dashboard, mark as complete immediately
   this.updateLoadingState('subscriberKeys', true);
  }
 };
 getTransactions = () => {
  if (this.state.StripeClientSecret !== "") {
   let body = {
    AccessToken: sessionStorage.getItem("AccessToken"),
    IdToken: sessionStorage.getItem("IdToken"),
    EmailAddress: this.state.email,
    VenueID: sessionStorage.getItem("venueID"),
   };
   axios
    .post("/venuemgmtconsole/subscribers/listPayments", body, {
     headers: {},
    })
    .then((response) => {
     setTimeout(() => {
      if (response.data.PaymentCount !== 0) {
       this.setState({
        mostRecentInvoice: response.data.Payments[response.data.PaymentCount - 1]["InvoiceDateTimeUTC.ISO8601"],
        invoiceDateRefund: response.data.Payments[response.data.PaymentCount - 1]["InvoiceDateTimeUTC.ISO8601"],
       });
      }
      this.setState({
       transactions: response.data.Payments,
      });
     }, 1000);
     let billing_cycle_end;
     let fixedBillingCycleHours = 0;
     const d = new Date(response.data.Payments[response.data.PaymentCount - 1]["InvoiceDateTimeUTC.ISO8601"]);
     if (response.data.Payments[response.data.PaymentCount - 1]["BillingCycleHours"] > 671) {
      billing_cycle_end = new Date(d.getFullYear(), d.getMonth() + 1, d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds());
      fixedBillingCycleHours = (billing_cycle_end.getTime() - d.getTime()) / (1000 * 60 * 60);
     } else {
      fixedBillingCycleHours = response.data.Payments[response.data.PaymentCount - 1]["BillingCycleHours"];
      billing_cycle_end = new Date(d.getTime() + response.data.Payments[response.data.PaymentCount - 1]["BillingCycleHours"] * 60 * 60 * 1000);
     }
     this.setState({
      billingCycleEnd: billing_cycle_end,
     });
     this.setState({
      refundAmountMax: (response.data.Payments[response.data.PaymentCount - 1]["AmountProcessed.USD"] / 100).toFixed(2),
      currencySymbol: response.data.Payments[response.data.PaymentCount - 1]["CurrencySymbol"],
      currency: response.data.Payments[response.data.PaymentCount - 1]["Currency"],
      invoiceDate: response.data.Payments[response.data.PaymentCount - 1]["InvoiceDateTimeUTC.ISO8601"],
      billingCycleHours: fixedBillingCycleHours,
      stripeClientSecret: response.data.Payments[response.data.PaymentCount - 1]["StripePaymentIntentId"],
      endRequestDate: undefined,
     });
     // Mark transactions loading as complete
     this.updateLoadingState('transactions', true);
    })
    .catch((error) => {
     this.setState({ error: true });
     // Mark transactions loading as complete even on error
     this.updateLoadingState('transactions', true);
    });
  } else {
   // If no StripeClientSecret, mark as complete immediately
   this.updateLoadingState('transactions', true);
  }
 };
 getLogs = () => {
  if (window.location.pathname === "/networkdashboard") {
   let body = {
    AccessToken: sessionStorage.getItem("AccessToken"),
    IdToken: sessionStorage.getItem("IdToken"),
    EmailAddress: this.state.email,
   };
   axios
    .post("/networkoperatorconsole/subscribers/listSubscriberLog", body, {
     headers: {},
    })
    .then((response) => {
     this.setState({
      subscriberLog: response.data.log,
     });
     // Mark logs loading as complete
     this.updateLoadingState('logs', true);
    })
    .catch((error) => {
     this.setState({ error: true });
     // Mark logs loading as complete even on error
     this.updateLoadingState('logs', true);
    });
  } else {
   // If not network dashboard, mark as complete immediately
   this.updateLoadingState('logs', true);
  }
 };
 getSubscriptions = () => {
  let body = {
   AccessToken: sessionStorage.getItem("AccessToken"),
   IdToken: sessionStorage.getItem("IdToken"),
   EmailAddress: this.state.email,
   VenueID: this.state.venueID,
   UnitID_internal: this.state.unitID_internal,
  };
  axios
   .post("/networkoperatorconsole/shoppingcart/listSubscriptions", body, {
    headers: {},
   })
   .then((response) => {
    const subscriptions = response.data.Subscriptions || {};
    const subscriptionKeys = Object.keys(subscriptions);
    // If multiple subscriptions, use the active one (no EndDateTimeUTC.ISO8601)
    const matchKey =
     subscriptionKeys.find(
      (key) =>
       !subscriptions[key]["EndDateTimeUTC.ISO8601"] ||
       subscriptions[key]["EndDateTimeUTC.ISO8601"] === ""
     ) || subscriptionKeys[0];
    if (matchKey !== undefined) {
     this.setState({ currentServicePlanID: subscriptions[matchKey]["CurrentServicePlanID"] });
    }
   })
   .catch((error) => {
    this.setState({ error: true });
   });
 };
 getDevices = (subscriberToken) => {
  if (window.location.pathname === "/networkdashboard") {
   let body = {
    AccessToken: sessionStorage.getItem("AccessToken"),
    IdToken: sessionStorage.getItem("IdToken"),
    SubscriberToken: subscriberToken,
    unitID_Internal: this.state.unitID_internal
   };
   axios
    .post("/operatorconsole/subscribers/listDevices", body, {
     headers: {},
    })
    .then((response) => {
     this.setState({
      devices: response.data.Devices,
     });
    })
    .catch((error) => {
     this.setState({ error: true });
    });
  }
 }
 toggleConfirmRemoveKey = (key) => {
  this.setState({
   modalConfirmRemoveKey: !this.state.modalConfirmRemoveKey,
  });
 };
 removeKeyConfirm = (key, keynetwork) => {
  this.toggleConfirmRemoveKey();
  this.setState({
   toggleConfirmRemoveKey: true,
   ConfirmRemoveKey: !this.state.modalConfirmRemoveKey,
   keySSID: this.state.subscriberKeys[key]["ssid"],
   keytag: this.state.subscriberKeys[key][keynetwork]["KeyTag"],
   keyID: keynetwork,
  });
 };
 closeShowWifiPassword = () => {
  this.setState({
   modalShowWifiPassword: !this.state.modalShowWifiPassword,
  });
 };
 toggleShowWifiPassword = (key, keynetwork) => {
  this.setState({
   key: key,
   modalShowWifiPassword: !this.state.modalShowWifiPassword,
   subcriberWifiPassword: this.state.subscriberKeys[key][keynetwork]["psk"],
   keyID: keynetwork,
   keySSID: key,
   keySSIDID: this.state.subscriberKeys[key]["key"],
  });
 };
 toggleConfirmShowWifiPassword = (key, keynetwork) => {
  this.setState({
   modalConfirmShowWifiPassword: !this.state.modalConfirmShowWifiPassword,
  });
 };
 toggleChangeWifiPassword = () => {
  this.setState({
   modalChangeWifiPassword: !this.state.modalChangeWifiPassword,
   count: 0,
   newpsk: "",
   lowercase: false,
   uppercase: false,
   charLength: false,
   number: false,
   specialChar: false,
   password: "."
  });
 };
 toggleGenerateWifiHandout = () => {
  this.setState({
   modalGenerateWifiHandout: !this.state.modalGenerateWifiHandout,
  });
 };
 openChangeWifiPassword = (key, keynetwork, ssidName, keyTag, keyID) => {
  if (this.state.subscriberKeys && this.state.subscriberKeys[key] && this.state.subscriberKeys[key][keynetwork]) {
   this.setState({
    keyID: keyID,
    modalChangeWifiPassword: !this.state.modalChangeWifiPassword,
    ssidName: ssidName,
    subcriberWifiPassword: this.state.subscriberKeys[key][keynetwork]["psk"],
    keySSID: key,
    // eslint-disable-next-line no-dupe-keys
    keyID: keynetwork,
    selectedKeyName: keyTag,
    count: 0,
    newpsk: "",
    lowercase: false,
    uppercase: false,
    charLength: false,
    number: false,
    specialChar: false
   });
  } else {
   // Handle the case where the data is missing.
   // You could display an error message, log it, or take other actions.
   console.error("Subscriber keys are not available for this key/network.");
  }
 };
 validateForm() {
  if (this.state.password !== null) {
   return this.state.password.split(".")[0].length >= 1;
  }
 }
 setPassword = (newpassword, password, token) => {
  let scrubbedPassword = newpassword.replace(/\./g, "");
  this.setState({ password: scrubbedPassword });
  this.setState({ newpsk: scrubbedPassword });
  this.setState({ token: token });
  this.passwordValidate(scrubbedPassword);
 };
 submitEditPassword = () => {
  this.setState({
   submittingPSKReset: true
  })
  if (this.state.password !== null) {
   let body;
   if (sessionStorage.getItem("showCustomPSK") === "true") {
    body = {
     AccessToken: sessionStorage.getItem("AccessToken"),
     IdToken: sessionStorage.getItem("IdToken"),
     CurrentKeyID: this.state.keyID,
     SubscriberToken: this.state.subscriberToken,
     NewKey: this.state.password.split(".")[0],
    };
   } else {
    body = {
     AccessToken: sessionStorage.getItem("AccessToken"),
     IdToken: sessionStorage.getItem("IdToken"),
     CurrentKeyID: this.state.keyID,
     SubscriberToken: this.state.subscriberToken,
     UserPartForNewKey: this.state.password.split(".")[0],
    }
   }
   axios
    .post("/networkoperatorconsole/subscribers/resetKey", body, {
     headers: {},
    })
    .then((response) => {
     this.setState({
      modalChangeWifiPassword: !this.state.modalChangeWifiPassword,
      submittingPSKReset: false
     });
     toast.success(response.data.message, {
      closeButton: false,
     });
     this.getSubscriberKeys(this.state.email);
    })
    .catch((error) => {
     this.setState({
      error: true,
      modalChangeWifiPassword: !this.state.modalChangeWifiPassword,
      submittingPSKReset: false
     });
     toast.success(error.response.data.message, {
      closeButton: false,
     });
    });
  } else {
   toast.error("We encountered an error. Please reload the page and try again.", {
    closeButton: false,
   });
  }
 };
 showWifiPasswordConfirm = (key, keynetwork) => {
  this.toggleConfirmShowWifiPassword();
 };
 passwordValidate = (newpassword) => {
  const value = newpassword;
  const regexNum = /\d/;
  const regexLowercase = /[a-z]/;
  const regexUppercase = /[A-Z]/;
  const regexCharLength = /^.{8,72}$/;
  const regexDot = /[.]/;
  const regexSpecialChar = /[!#+,-/:=@_]/; // Special characters excluding "."
  // const userEmail = this.state.userEmail;
  // const userName = userEmail.split("@")[0];
  
  // Check if this is the specific venue that requires special character validation
  const specialCharVenues = [
    "USA.AZ.85004.MEREONETWORKSMANAGEDPROPERTIES.PHOENIX._V3VENUE_.USA.AZ.85251.THEGLENATOLDTOWN.SCOTTSDALE",
    "USA.AZ.85004.MEREONETWORKSMANAGEDPROPERTIES.PHOENIX._V3VENUE_.USA.AZ.85251.VISCONTIATCAMELBAC.SCOTTSDALE",
    "USA.AZ.85004.MEREONETWORKSMANAGEDPROPERTIES.PHOENIX._V3VENUE_.USA.AZ.85251.THECORTESIAN.SCOTTSDALE",
    "USA.AZ.85004.MEREONETWORKSMANAGEDPROPERTIES.PHOENIX._V3VENUE_.USA.AZ.85004.CORTECAALTIPLANOTE.PHOENIX",
                  "USA.AZ.85004.MEREONETWORKSMANAGEDPROPERTIES.PHOENIX._V3VENUE_.USA.WI.53158.INSPIREPRAIRIESPRI.PLEASANTP"
  ];
  const requiresSpecialChar = specialCharVenues.includes(this.props.venueID);
  console.log("Current venueID:", this.props.venueID);
  console.log("requiresSpecialChar:", requiresSpecialChar);
  
  let count = 0;
  if (regexNum.test(value) === true) {
   this.setState({
    number: true,
    count: count + 1
   });
   count++;
  } else {
   this.setState({ number: false });
  }
  if (regexLowercase.test(value) === true) {
   this.setState({
    lowercase: true,
    count: count + 1
   });
   count++;
  } else {
   this.setState({ lowercase: false });
  }
  if (regexUppercase.test(value) === true) {
   this.setState({
    uppercase: true,
    count: count + 1
   });
   count++;
  } else {
   this.setState({ uppercase: false });
  }
  // Check for special character (excluding ".") if required for this venue
  if (requiresSpecialChar) {
   if (regexSpecialChar.test(value) === true) {
    this.setState({
     specialChar: true,
     count: count + 1
    });
    count++;
   } else {
    this.setState({ specialChar: false });
   }
  }
  if (regexCharLength.test(value) === true) {
   this.setState({
    charLength: true,
    count: count + 1
   });
   count++;
  } else {
   this.setState({ charLength: false });
  }
  if (regexDot.test(value) === true) {
   this.setState({
    dot: false,
    count: count - 1
   });
   count--;
  } else {
   this.setState({ dot: true });
  }
  
  // Adjust minimum count based on whether special character is required
  const minimumCount = requiresSpecialChar ? 5 : 4;
  if (count >= minimumCount) {
   let body = {
    "AccessToken": sessionStorage.getItem("AccessToken"),
    "IdToken": sessionStorage.getItem("IdToken"),
    "SubscriberToken": this.state.subscriberToken,
    "CurrentKeyID": this.state.keyID,
    "NewKey": newpassword,
    "dryRun": true
   }
   this.setState({
    loadingPasswordStrength: true
   })
   axios
    .post("/networkoperatorconsole/subscribers/resetKey", body, { headers: {} })
    .then((response) => {
     if (response.data.message === "Strong Wi-Fi password. ") {
      this.setState({
       count: count + 1,
       loadingPasswordStrength: false,
       passwordInvalid: false
      })
     } else {
      this.setState({
       // count: count - 1,
       loadingPasswordStrength: false,
       passwordInvalid: true
      })
     }
    })
    .catch((error) => {
     this.setState({
      error: true,
      loadingPasswordStrength: false,
      passwordInvalid: true,
      count: count - 1,
     });
     // toast.error(t("profiledetails.passwordnotupdated"), {
     //   closeButton: false,
     // });
    });
  }
  // regexNum.test(value)
  //   ? (this.setState({ number: true }), count++)
  //   : this.setState({ number: false });
  // regexLowercase.test(value)
  //   ? this.setState({ lowercase: true })
  //   : this.setState({ lowercase: false });
  // regexUppercase.test(value)
  //   ? this.setState({ uppercase: true })
  //   : this.setState({ uppercase: false });
  // regexCharLength.test(value)
  //   ? this.setState({ charLength: true })
  //   : this.setState({ charLength: false });
  // !value.toLowerCase().includes(userName.toLowerCase())
  //   ? this.setState({ emailMatch: true })
  //   : this.setState({ emailMatch: false });
 }
 submitRemoveKey = (event) => {
  let body = {
   AccessToken: sessionStorage.getItem("AccessToken"),
   IdToken: sessionStorage.getItem("IdToken"),
   SubscriberToken: this.state.subscriberToken,
   KeyID: this.state.keyID,
  };
  this.setState({ loadingRemoveKey: true });
  axios
   .post("/networkoperatorconsole/subscribers/removeKey", body, {
    headers: {},
   })
   .then((response) => {
    toast.success("Removed Key!", {
     closeButton: false,
    });
    this.toggleConfirmRemoveKey();
    this.getSubscriberKeys();
    this.setState({ loadingRemoveKey: false });
   })
   .catch((error) => {
    toast.error("There was an error!", {
     closeButton: false,
    });
    this.setState({ loadingRemoveKey: false });
   });
 };
 toggleAddKey = (key) => {
  this.setState({
   toggleAddKey: true,
   modal: !this.state.modal,
  });
 };
 submitAddKey = (keypoolID, unitID_internal) => {
  let body = {
   AccessToken: sessionStorage.getItem("AccessToken"),
   IdToken: sessionStorage.getItem("IdToken"),
   EmailAddress: this.state.email,
   KeyPoolID: keypoolID,
   GivenName: this.state.firstName,
   FamilyName: this.state.lastName,
   "PhoneNumber.E164": this.state.phoneNumber,
   VenueID: this.state.venueID,
   PolicyforSubscriberKey: {
    UnitID_internal: unitID_internal,
   },
  };
  this.setState({ loadingAddKey: true });
  axios
   .post("/networkoperatorconsole/subscribers/addKey", body, {
    headers: {},
   })
   .then((response) => {
    toast.success("Added Key!", {
     closeButton: false,
    });
    this.toggleAddKey();
    this.getSubscriberKeys();
    this.setState({ loadingAddKey: false });
   })
   .catch((error) => {
    toast.error("There was an error!", {
     closeButton: true,
    });
    this.setState({ loadingAddKey: false });
   });
 };
 handleSelectChangeServicePlan = (event, { name, value }) => {
  this.setState({
   selectedServicePlanID: this.state.availablePlans[value]["ServicePlanID"],
   selectedServicePlanName: name,
   selectedServicePlanIndex: value,
   selectedServicePlanPrice: getSymbolFromCurrency(this.state.currencyCode) + (this.state.availablePlans[value]["BillingCyclePrice." + this.state.currencyCode] / 100).toFixed(2),
   netBillingPrice: ((this.state.availablePlans[value]["BillingCyclePrice." + this.state.currencyCode] + this.state.venuePriceAdjustmentNumber + this.state.subscriptionDiscount * 100) / 100).toFixed(2),
   selectedServicePlanPriceNumber: (this.state.availablePlans[value]["BillingCyclePrice." + this.state.currencyCode] / 100).toFixed(2),
  });
 };
 handleSelectChangeLanguage = (value) => {
  this.setState({ selectedLanguage: value });
 };
 changeHandlerSubscriptionDiscount = (event) => {
  this.setState({
   subscriptionDiscount: -Math.abs(event.target.value).toFixed(2),
  });
  this.setState({
   netBillingPrice: ((this.state.selectedServicePlanPriceNumber * 100 + this.state.venuePriceAdjustmentNumber + (-Math.abs(event.target.value)).toFixed(2) * 100) / 100).toFixed(2),
  });
 };
 submitHandler = (event) => {
  let isUpdated;
  let isUpdatedServicePlan;
  let isUpdatedStartDate;
  let isUpdatedEndDate;
  let isUpdatedSubscriptionDiscount;
  event.preventDefault();
  event.target.className += " was-validated";
  $("#selectLanguage").removeClass("is-invalid");
  if (this.state.selectedLanguage === undefined) {
   this.setState({
    invalidLanguage: "Please provide a valid language",
   });
   $("#selectLanguage").addClass("is-invalid");
  } else {
   $("#selectLanguage").addClass("is-valid");
  }
  $("#selectServicePlan").removeClass("is-invalid");
  if (this.state.selectedServicePlanID === undefined) {
   this.setState({
    invalidLanguage: "Please provide a valid service plan",
   });
   $("#selectServicePlan").addClass("is-invalid");
  } else {
   $("#selectServicePlan").addClass("is-valid");
  }
  $("#selectBuilding").removeClass("is-invalid");
  if (this.state.selectedBuilding === undefined) {
   this.setState({
    invalidLanguage: "Please select a valid Building",
   });
   $("#selectBuilding").addClass("is-invalid");
  } else {
   $("#selectBuilding").addClass("is-valid");
  }
  $("#selectFloor").removeClass("is-invalid");
  if (this.state.selectedFloor === undefined) {
   this.setState({
    invalidLanguage: "Please select a valid Floor",
   });
   $("#selectFloor").addClass("is-invalid");
  } else {
   $("#selectFloor").addClass("is-valid");
  }
  if (
   this.state.firstName !== this.props.firstName ||
   this.state.lastName !== this.props.lastName ||
   this.state.phoneNumber !== this.props.phoneNumber ||
   this.state.selectedLanguage !== this.props.language ||
   this.state.email !== this.props.email ||
   this.state.contactpref_email !== this.props.contactpref_email ||
   this.state.contactpref_sms !== this.props.contactpref_sms
  ) {
   isUpdated = true;
  }
  if (this.state.selectedServicePlanID !== this.props.servicePlanID) {
   isUpdatedServicePlan = true;
  }
  if (this.state.subscriptionDiscount !== -Math.abs(this.props.subscriptionDiscount)) {
   isUpdatedSubscriptionDiscount = true;
  }
  if (
   new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
   }).format(new Date(this.state.oldDateStart)) !== this.state.dateStart
  ) {
   isUpdatedStartDate = true;
  }
  if (this.state.oldDateEnd !== this.state.dateEnd) {
   isUpdatedEndDate = true;
  }
  // Validation is now handled by handleSaveChanges, so we can proceed directly
  // Clear continueToSMSAfterSave flag to prevent SMS modal from showing after regular form submission
  // this.setState({ continueToSMSAfterSave: false });
  this.props.submitModify(
   this.state.email.trim(),
   this.state.firstName.trim(),
   this.state.lastName.trim(),
   this.state.phoneNumber,
   this.state.selectedLanguage,
   this.state.contactpref_email,
   this.state.contactpref_sms,
   this.state.recentResidents,
   this.state.dateStart,
   this.state.oldDateStart,
   this.state.dateEnd,
   this.state.oldDateEnd,
   this.state.venueID,
   this.state.unitID,
   this.state.selectedBuilding,
   this.state.selectedFloor,
   this.state.selectedServicePlanID,
   isUpdated,
   isUpdatedServicePlan,
   isUpdatedStartDate,
   isUpdatedEndDate,
   isUpdatedSubscriptionDiscount,
   this.state.unitID_internal,
   this.state.selectedServicePlanName,
   this.state.subscriberToken,
   this.state.updatedUnit,
   this.state.subscriptionDiscount,
   this.state.setupIntentID
  );
 };
 changeHandler = (event) => {
  this.setState({ [event.target.name]: event.target.value });
 };
 changeHandlerPhone = (event) => {
  this.setState({
   phoneNumber: event,
   phoneNumberUpdated: event !== this.state.originalPhoneNumber
  });
  if (this.state.contactpref_sms === true && (event === "" || event === undefined || event === null)) {
   this.setState({
    invalidPhone: "Please add a phone number to the subscriber’s account.",
   });
   $(".PhoneInput").addClass("is-invalid");
  }
  else {
   this.setState({
    invalidPhone: null
   });
   $(".PhoneInput").removeClass("is-invalid");
  }
 };
 toggleCheckboxValueSMS = () => {
  const newContactPrefSMS = !this.state.contactpref_sms;
  this.setState({ contactpref_sms: !this.state.contactpref_sms });
  if (newContactPrefSMS === true && (this.state.phoneNumber === "" || this.state.phoneNumber === undefined || this.state.phoneNumber === null)) {
   this.setState({
    invalidPhone: "Please add a phone number to the subscriber’s account.",
   });
   $(".PhoneInput").addClass("is-invalid");
  }
  if (newContactPrefSMS === false && (this.state.phoneNumber === "" || this.state.phoneNumber === undefined || this.state.phoneNumber === null)) {
   this.setState({
    invalidPhone: null,
   });
   $(".PhoneInput").removeClass("is-invalid");
  }
 };
 toggleCheckboxValueEmail = () => {
  this.setState({ contactpref_email: !this.state.contactpref_email });
 };
 createMask = () => {
  this.setState({
   phoneNumber: this.state.phoneNumber.replace(/\D/g, ""),
  });
 };
 setEndDate = (dateStart) => {
  var endDateYear = new Date(dateStart).getFullYear() + 1;
  var endDate = new Date(dateStart).setFullYear(endDateYear);
  if (dateStart !== null) {
   this.setState({
    dateEnd: new Intl.DateTimeFormat("en-US", {
     year: "numeric",
     month: "2-digit",
     day: "2-digit",
    }).format(new Date(endDate)),
   });
  }
 };
 handleDayChange(dateStart, modifiers, dayPickerInput) {
  const input = dayPickerInput.getInput();
  this.setState({
   dateStart,
   isEmpty: !input.value.trim(),
   isDisabled: modifiers.disabled === true,
  });
 }
 handleDayChangeEnd(dateEnd, modifiers, dayPickerInput) {
  const input = dayPickerInput.getInput();
  this.setState({
   dateEnd,
   isEmpty: !input.value.trim(),
   isDisabled: modifiers.disabled === true,
  });
 }
 validateDate = (value) => {
  if (!value || value.trim() === "") {
   return null;
  }
  if (/[^0-9/]/.test(value)) {
   return "Only numbers and / are allowed";
  }
  if (!/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
   return "Date must be in MM/DD/YYYY format";
  }
  const parts = value.split("/");
  const month = parseInt(parts[0], 10);
  const day = parseInt(parts[1], 10);
  const year = parseInt(parts[2], 10);
  if (month < 1 || month > 12) {
   return "Month must be between 01 and 12";
  }
  if (day < 1 || day > 31) {
   return "Day must be between 01 and 31";
  }
  if (year < 2000 || year > 2099) {
   return "Year must be between 2000 and 2099";
  }
  const dateObj = new Date(year, month - 1, day);
  if (
   dateObj.getFullYear() !== year ||
   dateObj.getMonth() !== month - 1 ||
   dateObj.getDate() !== day
  ) {
   return "Invalid date";
  }
  // Check if date is in the past
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  dateObj.setHours(0, 0, 0, 0);
  if (dateObj < today) {
   return "Date cannot be in the past";
  }
  return null;
 };
 validateDateOnBlur = (name) => {
  const value = this.state[name];
  const error = this.validateDate(value);
  if (name === "dateStart") {
   this.setState({ invalidDateStart: error });
  } else if (name === "dateEnd") {
   if (!error && value && this.state.dateStart) {
    const startParts = this.state.dateStart.split("/");
    const endParts = value.split("/");
    if (startParts.length === 3 && endParts.length === 3) {
     const startDate = new Date(
      parseInt(startParts[2], 10),
      parseInt(startParts[0], 10) - 1,
      parseInt(startParts[1], 10)
     );
     const endDate = new Date(
      parseInt(endParts[2], 10),
      parseInt(endParts[0], 10) - 1,
      parseInt(endParts[1], 10)
     );
     if (endDate <= startDate) {
      this.setState({
       invalidDateEnd: "End date must be after start date",
      });
      return;
     }
    }
   }
   this.setState({ invalidDateEnd: error });
  }
 };
 handleChange = (event, { name, value }) => {
  if (this.state.hasOwnProperty(name)) {
   if (name === "dateStart" || name === "dateEnd") {
    const cleaned = value.replace(/[^0-9/]/g, "");
    this.setState({ [name]: cleaned });
    if (value !== cleaned) {
     this.setState({
      [name === "dateStart" ? "invalidDateStart" : "invalidDateEnd"]:
       "Only numbers and / are allowed",
     });
    } else {
     this.setState({
      [name === "dateStart" ? "invalidDateStart" : "invalidDateEnd"]: null,
     });
    }
   } else {
    this.setState({ [name]: value });
   }
  }
 };
 toggleConfirmDeletion = (key) => {
  this.setState({
   toggleConfirm: true,
   modal: !this.state.modal,
  });
 };
 submitDelete = (event) => {
  let cancellationReason = [];
  this.state.radio.length === 0 ? (cancellationReason = this.state.reason) : cancellationReason.push(this.state.radio);
  cancellationReason = cancellationReason.filter((item) => item !== "other");
  if (this.state.reason.includes("other") || this.state.radio.includes("other")) {
   cancellationReason.push("Other: " + this.state.otherSpecify);
  }
  if (cancellationReason.length === 0) {
   this.setState({
    cancelErrorMessage: "Please select a reason for cancellation",
   });
  } else {
   this.setState({ cancelErrorMessage: "", loadingDelete: true });
   this.props.submitDelete(this.state.email, this.state.venueID, this.state.unitID, this.state.building, this.state.floor, this.state.recentResidents, this.state.oldDateStart, this.state.unitID_internal, cancellationReason, this.state.refundAmount * 100);
  }
 };
 toggle = () => {
  this.setState({
   modal: !this.state.modal,
   modalMessage: !this.state.modalMessage,
  });
 };
 toggleMessageSend = () => {
  this.setState({
   modalMessageSend: !this.state.modalMessageSend,
   subject: undefined,
   emailMessage: undefined,
  });
 };
 toggleMessage = (key) => {
  this.setState({
   modalMessage: !this.state.modalMessage,
   messageID: key,
  });
 };
 submitMessage = () => {
  this.setState({ loadingMessages: true });
  let body = {
   AccessToken: sessionStorage.getItem("AccessToken"),
   IdToken: sessionStorage.getItem("IdToken"),
   VenueID: this.props.venueID,
   UnitID_internal: this.state.unitID_internal,
   EmailAddress: this.state.email,
   Subject: this.state.subject,
   Message: this.state.emailMessage,
  };
  axios
   .post("/venuemgmtconsole/subscribers/sendMessage", body, {
    headers: {},
   })
   .then((response) => {
    toast.success("Message Sent!", {
     closeButton: false,
    });
    this.setState({
     modalMessageSend: !this.state.modalMessageSend,
    });
    this.getMessages(this.props.venueID);
   })
   .catch((error) => {
    toast.error("There was an error!", {
     closeButton: false,
    });
    this.setState({ error: true });
   });
 };
 handleEditorChange(emailMessage, editor) {
  this.setState({ emailMessage });
 }
 toggleTab = (tab) => () => {
  if (this.state.activeItem !== tab) {
   this.setState({
    activeItem: tab,
   });
  }
 };
 toggleTabRefund = (tabRefund) => () => {
  if (this.state.activeItemRefund !== tabRefund) {
   this.setState({
    activeItemRefund: tabRefund,
   });
  }
 };
 toggleResendActivation = () => {
  this.setState({
   modalResendActivation: !this.state.modalResendActivation,
  });
 };
 toggleMoveVenue = () => {
  const newModalState = !this.state.modalMoveVenue;
  this.setState({
   modalMoveVenue: newModalState,
   selectedDestinationVenue: "",
   selectedDestinationUnit: "",
   destinationVenueUnits: [],
   destinationVenueServicePlans: [],
  });
  
  // Load venues when opening modal
  if (newModalState && this.state.venues.length === 0) {
   this.getVenuesForMove();
  }
 };
 getVenuesForMove = () => {
  let body = {
   AccessToken: sessionStorage.getItem("AccessToken"),
   IdToken: sessionStorage.getItem("IdToken"),
  };
  
  axios
   .post("/networkoperatorconsole/venues/listVenues", body, {
    headers: {},
   })
   .then((response) => {
    // Convert VenueList object to array format
    const venuesArray = response.data.VenueList ? 
     Object.keys(response.data.VenueList).map(venueID => ({
      VenueID: venueID,
      VenueName: response.data.VenueList[venueID].VenueName
     })) : [];
    
    this.setState({ 
     venues: venuesArray
    });
   })
   .catch((error) => {
    toast.error("Error loading venues");
    console.error("Error loading venues:", error);
   });
 };
 toggleResendActivationSMSConfirm = () => {
  this.setState({
   modalResendActivationSMSConfirm: !this.state.modalResendActivationSMSConfirm,
   resendSMSConfirmOne: false,
   resendSMSConfirmTwo: false,
  });
 };
 togglePhoneNumberUpdateRequired = () => {
  this.setState({
   modalPhoneNumberUpdateRequired: !this.state.modalPhoneNumberUpdateRequired,
  });
 };
 handleResendSMSClick = () => {
  // Check if phone number has been updated
  if (this.state.phoneNumberUpdated) {
   // Show the phone number update required modal
   this.setState({ modalPhoneNumberUpdateRequired: true });
  } else {
   // Proceed with normal SMS confirmation flow
   this.toggleResendActivationSMSConfirm();
  }
 };
 handleSaveAndContinueSMS = () => {
  // Close the phone number update modal
  this.setState({ modalPhoneNumberUpdateRequired: false });
  // Save the changes first, then proceed with SMS
  this.handleSaveChanges(true); // Pass true to indicate we should continue to SMS after save
 };
 handleDestinationVenueChange = (e) => {
  const venueID = e.target.value;
  this.setState({ 
   selectedDestinationVenue: venueID,
   selectedDestinationUnit: "",
   destinationVenueUnits: [],
   destinationVenueServicePlans: [],
  });
  
  // Load units for the selected venue
  if (venueID) {
   this.getDestinationVenueUnits(venueID);
  }
 };
 getDestinationVenueUnits = (venueID) => {
  let body = {
   AccessToken: sessionStorage.getItem("AccessToken"),
   IdToken: sessionStorage.getItem("IdToken"),
   VenueID: venueID,
   UserTimeZone: new Date().getTimezoneOffset(),
  };
  
  axios
   .post("/venuemgmtconsole/venues/listVenueDetails", body, {
    headers: {},
   })
   .then((response) => {
    const unitData = response.data[venueID]["Units-Building-Floor-List-Subscribers"];
    const units = Object.keys(unitData);
    const unitsArray = [];
    
    // Parse the nested structure to create a flat array of units
    // Only include units without active subscriptions and without "TEMP" in the name
    for (let i = 0; i < units.length; i++) {
     // Skip units with "TEMP" in the name
     if (units[i].includes("TEMP")) {
      continue;
     }
     
     const buildings = Object.keys(unitData[units[i]]);
     for (let j = 0; j < buildings.length; j++) {
      const floors = Object.keys(unitData[units[i]][buildings[j]]);
      for (let k = 0; k < floors.length; k++) {
       const unit = unitData[units[i]][buildings[j]][floors[k]];
       
       // Check if unit has active subscriptions
       const subscriptions = unit["Subscriptions"] || {};
       const hasActiveSubscription = Object.keys(subscriptions).length > 0;
       
       // Only add units without active subscriptions
       if (!hasActiveSubscription) {
        unitsArray.push({
         UnitID: units[i],
         Building: buildings[j] !== "undefined" ? buildings[j] : "",
         Floor: floors[k] !== "undefined" ? floors[k] : "",
         UnitID_internal: unit["UnitID_internal"]
        });
       }
      }
     }
    }
    
    // Store available service plans for destination venue
    const servicePlans = response.data[venueID]["AvailableServicePlans"] || [];
    
    this.setState({ 
     destinationVenueUnits: unitsArray,
     destinationVenueServicePlans: servicePlans
    });
   })
   .catch((error) => {
    toast.error("Error loading units for selected venue");
    console.error("Error loading destination venue units:", error);
   });
 };
 submitMoveVenue = () => {
  if (!this.state.selectedDestinationVenue || !this.state.selectedDestinationUnit) {
   toast.error("Please select both a destination venue and unit");
   return;
  }
  
  if (this.state.selectedDestinationVenue === this.props.venueID && 
      this.state.selectedDestinationUnit === this.props.unitID_internal) {
   toast.error("Cannot move to the same venue and unit");
   return;
  }
  
  // Check if current service plan is available in destination venue
  const currentServicePlanID = this.props.servicePlanID;
  const destinationServicePlans = this.state.destinationVenueServicePlans;
  const servicePlanExists = Object.values(destinationServicePlans).some(
   plan => plan.ServicePlanID === currentServicePlanID
  );
  
  if (!servicePlanExists) {
   toast.error("The current service plan is not available in the destination venue. Please contact support to move this subscription.");
   return;
  }
  
  this.setState({ loadingMoveVenue: true });
  
  // Step 1: End current subscription using resetSubscriptionEndDate
  let endSubBody = {
   AccessToken: sessionStorage.getItem("AccessToken"),
   IdToken: sessionStorage.getItem("IdToken"),
   EmailAddress: this.state.email,
   VenueID: this.props.venueID,
   UnitID_internal: this.props.unitID_internal,
   "StartDateTimeUTC.ISO8601": this.props.startDate,
   "NewEndDateTimeUTC.ISO8601": this.props.startDate,
   endImmediately: true,
   UserTimeZone: new Date().getTimezoneOffset(),
   CancellationReasons: ["Moved to another venue"],
   requestedRefundAmount: 0,
  };
  
  axios
   .post("/venuemgmtconsole/subscribers/resetSubscriptionEndDate", endSubBody, {
    headers: {},
   })
   .then((response) => {
    if (response.data.errorProcessing) {
     throw new Error(response.data.message || "Error ending subscription");
    }
    // Add delay before creating new subscription
    return new Promise(resolve => setTimeout(resolve, 3000));
   })
   .then(() => {
    // Step 2: Create new subscription at destination using addSubscriber
    // Find the destination unit by UnitID_internal
    const destinationUnit = this.state.destinationVenueUnits.find(
     unit => unit.UnitID_internal === this.state.selectedDestinationUnit
    );
    
    if (!destinationUnit) {
     throw new Error("Destination unit not found");
    }
    
    // Use the existing subscription's end date
    const startDate = new Date();
    const endDate = this.props.endDate ? new Date(this.props.endDate) : undefined;
    
    let createSubBody = {
     AccessToken: sessionStorage.getItem("AccessToken"),
     IdToken: sessionStorage.getItem("IdToken"),
     EmailAddress: this.state.email,
     GivenName: this.state.firstName,
     FamilyName: this.state.lastName,
     "PhoneNumber.E164": this.state.phoneNumber,
     locale: this.state.selectedLanguage,
     "EndDateTimeUTC.ISO8601": endDate ? endDate.toISOString().replace(/:00.\d+Z$/g, "Z") : undefined,
     "StartDateTimeUTC.ISO8601": startDate.toISOString().replace(/:00.\d+Z$/g, "Z"),
     VenueID: this.state.selectedDestinationVenue,
     PolicyforSubscriberKey: {
      UnitID_internal: destinationUnit.UnitID_internal,
     },
     contactpref_email: this.state.contactpref_email,
     contactpref_sms: this.state.contactpref_sms,
     UserTimeZone: new Date().getTimezoneOffset(),
     ServicePlanID: this.props.servicePlanID,
    };
    
    // Generate NewKey for specific venue IDs
    const specialCharVenues = [
      "USA.AZ.85004.MEREONETWORKSMANAGEDPROPERTIES.PHOENIX._V3VENUE_.USA.AZ.85251.THEGLENATOLDTOWN.SCOTTSDALE",
      "USA.AZ.85004.MEREONETWORKSMANAGEDPROPERTIES.PHOENIX._V3VENUE_.USA.AZ.85251.VISCONTIATCAMELBAC.SCOTTSDALE",
      "USA.AZ.85004.MEREONETWORKSMANAGEDPROPERTIES.PHOENIX._V3VENUE_.USA.AZ.85251.THECORTESIAN.SCOTTSDALE",
      "USA.AZ.85004.MEREONETWORKSMANAGEDPROPERTIES.PHOENIX._V3VENUE_.USA.AZ.85004.CORTECAALTIPLANOTE.PHOENIX",
                  "USA.AZ.85004.MEREONETWORKSMANAGEDPROPERTIES.PHOENIX._V3VENUE_.USA.WI.53158.INSPIREPRAIRIESPRI.PLEASANTP"
    ];
    if (specialCharVenues.includes(this.state.selectedDestinationVenue)) {
        const generateNewKey = () => {
            const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
            const lowercase = "abcdefghijklmnopqrstuvwxyz";
            const numbers = "0123456789";
            const specialChars = "!#+,-/:=@_";
            const allChars = uppercase + lowercase + numbers + specialChars;
            
            let password = [
                uppercase[Math.floor(Math.random() * uppercase.length)],
                lowercase[Math.floor(Math.random() * lowercase.length)],
                numbers[Math.floor(Math.random() * numbers.length)],
                specialChars[Math.floor(Math.random() * specialChars.length)]
            ];
            
            for (let i = 0; i < 8; i++) {
                password.push(allChars[Math.floor(Math.random() * allChars.length)]);
            }
            
            for (let i = password.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [password[i], password[j]] = [password[j], password[i]];
            }
            
            // Ensure first character is not a special character
            if (specialChars.includes(password[0])) {
                const nonSpecialIndex = password.findIndex(c => !specialChars.includes(c));
                [password[0], password[nonSpecialIndex]] = [password[nonSpecialIndex], password[0]];
            }
            
            return password.join("");
        };
        
        createSubBody.NewKey = generateNewKey();
    }
    
    return axios.post("/venuemgmtconsole/subscribers/addSubscriber", createSubBody, {
     headers: {},
    });
   })
   .then((response) => {
    if (response.data.errorProcessing) {
     throw new Error(response.data.message || "Error ending subscription");
    }
    // Capture values before any state changes
    const newVenueID = this.state.selectedDestinationVenue;
    const newUnitID_internal = this.state.selectedDestinationUnit;
    const destinationUnit = this.state.destinationVenueUnits.find(
     unit => unit.UnitID_internal === newUnitID_internal
    );
    
    this.setState({ loadingMoveVenue: false });
    toast.success("Subscription successfully moved to new venue");
    this.toggleMoveVenue(); // Close the move venue modal (this resets selectedDestinationVenue)
    
    // Update the venue details to show the new venue
    this.setState({
     venueID: newVenueID,
     unitID: destinationUnit?.UnitID,
     unitID_internal: destinationUnit?.UnitID_internal,
     selectedUnit: destinationUnit?.UnitID,
     selectedBuilding: destinationUnit?.Building,
     selectedFloor: destinationUnit?.Floor,
     building: destinationUnit?.Building,
     floor: destinationUnit?.Floor,
    }, () => {
     // Callback after state is updated - now refresh all data
     console.log("Calling getVenueDetails with newVenueID:", newVenueID);
     this.getVenueDetails(newVenueID);
     this.getMessages(newVenueID);
     this.getSubscriberKeys();
     this.getTransactions();
     this.getLogs();
     
     // Refresh parent component's subscriber table if available
     if (this.props.getVenueDetails) {
      // For ViewVenueSubscribers - refresh the original venue to remove the subscriber
      this.props.getVenueDetails(this.props.venueID);
     }
    });
    
    if (this.props.refreshUnits) {
     this.props.refreshUnits(); // Refresh unit list in parent (for ViewUnitStatus)
    }
   })
   .catch((error) => {
    this.setState({ loadingMoveVenue: false });
    toast.error("Error moving subscription: " + (error.response?.data?.message || error.message));
    console.error("Error moving subscription:", error);
   });
 };
 toggleCheckboxValueSMSConfirmOne = () => {
  this.setState({ resendSMSConfirmOne: !this.state.resendSMSConfirmOne });
 };
 toggleCheckboxValueSMSConfirmTwo = () => {
  this.setState({ resendSMSConfirmTwo: !this.state.resendSMSConfirmTwo });
 };
 formatPhoneNumber = (phoneNumberString) => {
  var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
   var intlCode = match[1] ? "" : "";
   return [
    intlCode,
    "(",
    match[2],
    ") ",
    match[3],
    "-",
    match[4],
   ].join("");
  }
  return phoneNumberString; // Return original if formatting fails
 };
 submitHandlerResendActivationSMS = () => {
  let body = {
   AccessToken: sessionStorage.getItem("AccessToken"),
   IdToken: sessionStorage.getItem("IdToken"),
   EmailAddress: this.state.email,
   VenueID: this.props.venueID,
   UserTimeZone: new Date().getTimezoneOffset(),
   NotificationChannel: "SMS",
   "PhoneNumber.E164": this.state.phoneNumber
  };
  this.setState({ loadingResendSMS: true });
  axios
   .post("/venuemgmtconsole/subscribers/resendCodeforTandC", body, {
    headers: {},
   })
   .then(
    (response) => {
     toast.success("Resent Confirmation!", {
      closeButton: false,
     });
     this.setState({
      loadingResendSMS: false,
      modalResendActivation: false,
      modalResendActivationSMSConfirm: false,
     });
    },
    (error) => {
     toast.error("There was an error!", {
      closeButton: false,
     });
     this.setState({
      loadingResendSMS: false,
      modalResendActivation: false,
      modalResendActivationSMSConfirm: false,
     });
    }
   );
 };
 submitHandlerResendActivationEmail = () => {
  let body = {
   AccessToken: sessionStorage.getItem("AccessToken"),
   IdToken: sessionStorage.getItem("IdToken"),
   EmailAddress: this.state.email,
   VenueID: this.props.venueID,
   UserTimeZone: new Date().getTimezoneOffset(),
  };
  this.setState({ loadingResend: true });
  axios
   .post("/venuemgmtconsole/subscribers/resendCodeforTandC", body, {
    headers: {},
   })
   .then(
    (response) => {
     toast.success("Resent Confirmation!", {
      closeButton: false,
     });
     this.setState({
      loadingResend: false,
      modalResendActivation: false,
     });
    },
    (error) => {
     toast.error("There was an error!", {
      closeButton: false,
     });
     this.setState({
      loadingResend: false,
      modalResendActivation: false,
     });
    }
   );
 };
 toggleCancel = () => {
  this.setState({
   modalCancel: !this.state.modalCancel,
  });
 };
 changeHandlerCheckbox = (event) => {
  this.setState({ [event.target.name]: !this.state[event.target.name] });
  if (!this.state[event.target.name] === true) {
   // Checkbox is being checked - add to reason array
   this.setState((prevState) => ({
    reason: [...prevState.reason, event.target.name],
   }));
  } else {
   // Checkbox is being unchecked - remove from reason array
   this.setState((prevState) => ({
    reason: prevState.reason.filter(item => item !== event.target.name),
   }));
  }
 };
 changeHandlerRadio = (nr) => () => {
  this.setState({
   radio: nr,
  });
 };
 changeHandlerOtherSpecify = (event) => {
  this.setState({ otherSpecify: event.target.value });
 };
 deviceDetails = (device) => {
  this.setState({
   modalDeviceDetails: !this.state.modalDeviceDetails,
   deviceDetails: device,
  });
 };
 toggleDeviceDetailsClose = () => {
  this.setState({
   modalDeviceDetails: !this.state.modalDeviceDetails,
  });
 };
 toggleRefund = (refundAmount, refundAmountMax, currencySymbol, currency, invoiceDateRefund, billingCycleHours, stripeClientSecret, stripeClientParentSecret, amountAlreadyRefunded) => {
  let billing_cycle_end;
  let fixedBillingCycleHours = 0;
  const d = new Date(invoiceDateRefund);
  if (billingCycleHours > 671) {
   billing_cycle_end = new Date(d.getFullYear(), d.getMonth() + 1, d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds());
   fixedBillingCycleHours = (billing_cycle_end.getTime() - d.getTime()) / (1000 * 60 * 60);
  } else {
   fixedBillingCycleHours = billingCycleHours;
   billing_cycle_end = new Date(d.getTime() + billingCycleHours * 60 * 60 * 1000);
  }
  this.setState({
   billingCycleEnd: billing_cycle_end,
  });
  this.setState({
   modalRefund: !this.state.modalRefund,
   refundAmount: (refundAmount / 100).toFixed(2),
   refundAmountMax: (refundAmountMax / 100).toFixed(2),
   currencySymbol: currencySymbol,
   currency: currency,
   invoiceDateRefund: invoiceDateRefund,
   billingCycleHours: fixedBillingCycleHours,
   stripeClientSecret: stripeClientSecret,
   stripeClientParentSecret: stripeClientParentSecret,
   endRequestDate: undefined,
   activeItemRefund: this.isNetworkAdmin() ? "1" : "2",
  });
 };
 isNetworkAdmin = () => sessionStorage.getItem("networkAdmin") > 0;
 changeHandlerRefundEndDate = (event, { name, value }) => {
  this.setState({ endRequestDate: value });
  let pricehr = parseInt(this.state.refundAmountMax) / this.state.billingCycleHours;
  if (new Date(value).getTime() < new Date(this.state.invoiceDateRefund).getTime()) {
   value = new Date(this.state.invoiceDateRefund).getTime();
  }
  let hours_remaining = Math.floor((this.state.billingCycleEnd.getTime() - new Date(value).getTime()) / (1000 * 60 * 60));
  let amount_to_refund = hours_remaining * pricehr;
  if (amount_to_refund > this.state.refundAmountMax) {
   this.setState({
    refundAmount: this.state.refundAmountMax,
   });
  } else {
   this.setState({
    refundAmount: amount_to_refund.toFixed(2),
   });
  }
 };
 submitRefund = () => {
  this.setState({
   submittingRefund: true,
  });
  $("#refundAmount").removeClass("is-invalid");
  if (parseInt(this.state.refundAmount) > parseInt(this.state.refundAmountMax)) {
   this.setState({
    invalidRefund: "Refund cannot be more than amount paid",
   });
   $("#refundAmount").addClass("is-invalid");
   $("#refundAmount").removeClass("is-valid");
  } else {
   $("#refundAmount").addClass("is-valid");
  }
  let body = {
   AccessToken: sessionStorage.getItem("AccessToken"),
   IdToken: sessionStorage.getItem("IdToken"),
   VenueID: this.props.venueID,
   StripeClientSecret: this.state.stripeClientSecret,
   Currency: this.state.currency,
   RefundAmount: this.state.refundAmount * 100,
   Reason: this.state.refundMemo,
  };
  let api;
  if ($(".invalid-feedback").is(":visible") !== true) {
   if (window.location.pathname === "/networkdashboard") {
    api = "/networkoperatorconsole/subscribers/refundPayment";
   } else {
    api = "/venuemgmtconsole/subscribers/refundPayment";
   }
   axios
    .post(api, body, {
     headers: {},
    })
    .then(
     (response) => {
      toast.success("Refund Submitted!", {
       closeButton: false,
      });
      this.setState({ loadingResend: false, modalRefund: false });
      this.getTransactions();
      this.setState({
       submittingRefund: false,
      });
     },
     (error) => {
      toast.error("There was an error!", {
       closeButton: false,
      });
      this.setState({ loadingResend: false, modalRefund: false });
      this.setState({
       submittingRefund: false,
      });
     }
    );
  }
 };
 submitCredit = () => {
  if (!this.isNetworkAdmin()) {
   toast.error("Only Network Admins can process credits.", { closeButton: false });
   return;
  }
  this.setState({
   submittingCredit: true,
  });
  $("#refundAmount").removeClass("is-invalid");
  if (parseInt(this.state.refundAmount) > parseInt(this.state.refundAmountMax)) {
   this.setState({
    invalidRefund: "Credit cannot be more than amount paid",
   });
   $("#refundAmount").addClass("is-invalid");
   $("#refundAmount").removeClass("is-valid");
   this.setState({ submittingCredit: false });
   return;
  } else {
   $("#refundAmount").addClass("is-valid");
  }
  // Credit must always be sent as a non-positive value.
  // - If the user entered a value <= 0, send it as-is.
  // - If the user entered a value > 0, negate it before sending.
  const creditAmountCents = this.state.refundAmount * 100;
  const normalizedCreditAmount = creditAmountCents <= 0 ? creditAmountCents : -creditAmountCents;
  
  console.log("submitCredit - stripeClientParentSecret:", this.state.stripeClientParentSecret);
  
  let body = {
   AccessToken: sessionStorage.getItem("AccessToken"),
   IdToken: sessionStorage.getItem("IdToken"),
   StripeClientSecret: this.state.stripeClientParentSecret,
   NewBillingCyclePriceAdjustment: normalizedCreditAmount,
   Reason: this.state.refundMemo,
  };
  
  console.log("submitCredit - request body:", body);
  
  let api;
  if (window.location.pathname === "/networkdashboard") {
   api = "/networkoperatorconsole/subscribers/applyOneTimeCredit";
  } else {
   api = "/networkoperatorconsole/subscribers/applyOneTimeCredit";
  }
  axios
   .post(api, body, {
    headers: {},
   })
   .then(
    (response) => {
     toast.success("Credit Submitted!", {
      closeButton: false,
     });
     this.setState({ loadingResend: false, modalRefund: false });
     this.getTransactions();
     this.setState({
      submittingCredit: false,
     });
    },
    (error) => {
     toast.error("There was an error!", {
      closeButton: false,
     });
     this.setState({ loadingResend: false, modalRefund: false });
     this.setState({
      submittingCredit: false,
     });
    }
   );
 };
 copySubscriberToken = () => {
  var copyText = document.getElementById("subscriberTokenHidden");
  var textArea = document.createElement("textarea");
  textArea.value = copyText.textContent;
  document.body.appendChild(textArea);
  textArea.select();
  document.execCommand("Copy");
  this.setState({ copyText: "Copied" });
  textArea.remove();
  toast.success("Subscriber Token copied", {
   closeButton: false,
  });
 };
 copyExternalSubscriberID = () => {
  var copyText = document.getElementById("externalSubscriberIDHidden");
  var textArea = document.createElement("textarea");
  textArea.value = copyText.textContent;
  document.body.appendChild(textArea);
  textArea.select();
  document.execCommand("Copy");
  this.setState({ copyText: "Copied" });
  textArea.remove();
  toast.success("External Subscriber ID copied", {
   closeButton: false,
  });
 };
 copyStripeCustomerID = () => {
  var copyText = document.getElementById("stripeCustomerIDHidden");
  var textArea = document.createElement("textarea");
  textArea.value = copyText.textContent;
  document.body.appendChild(textArea);
  textArea.select();
  document.execCommand("Copy");
  this.setState({ copyText: "Copied" });
  textArea.remove();
  toast.success("Stripe Customer ID copied", {
   closeButton: false,
  });
 };
 togglePSKValidator = (key) => {
  this.setState({
   modalPSKValidator: !this.state.modalPSKValidator,
  });
 };
 toggleValidationRequirements = () => {
  this.setState({
   modalValidationRequirements: !this.state.modalValidationRequirements,
  });
 };
 checkValidationRequirements = () => {
  const errors = [];
  if (!this.state.email || this.state.email.trim() === "") {
   errors.push("Email is required");
  } else {
   // Basic email format validation
   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
   if (!emailRegex.test(this.state.email.trim())) {
    errors.push("Valid email format is required");
   }
  }
  if (!this.state.firstName || this.state.firstName.trim() === "") {
   errors.push("First Name is required");
  }
  if (!this.state.lastName || this.state.lastName.trim() === "") {
   errors.push("Last Name is required");
  }
  if (!this.state.selectedLanguage) {
   errors.push("Language selection is required");
  }
  if (!this.state.selectedServicePlanID) {
   errors.push("Service Plan selection is required");
  }
  if (!this.state.selectedBuilding) {
   errors.push("Building selection is required");
  }
  if (!this.state.selectedFloor) {
   errors.push("Floor selection is required");
  }
  this.setState({ validationErrors: errors });
  if (errors.length > 0) {
   this.setState({ modalValidationRequirements: true });
   return false;
  }
  return true;
 };
 handleSaveChanges = (continueToSMS) => {
  console.log("handleSaveChanges called with continueToSMS:", continueToSMS);
  // Store whether to continue to SMS after save
  this.setState({ continueToSMSAfterSave: continueToSMS });
  // First run validation check
  const isValid = this.checkValidationRequirements();
  // If validation passes, check for email change
  if (isValid) {
   // Check if email was changed (only for Network Admin)
   const emailChanged = this.state.email !== this.state.originalEmail && 
                        window.location.pathname === "/networkdashboard" &&
                        sessionStorage.getItem("networkAdmin") > 0;
   
   if (emailChanged) {
    // Show email change confirmation modal
    this.setState({ modalEmailChangeConfirm: true });
   } else {
    // Proceed with save as normal
    this.proceedWithSave(continueToSMS);
   }
  }
  // If validation fails, the modal will be shown by checkValidationRequirements
 };
 
 proceedWithSave = (continueToSMS) => {
  // Set loading state to show modification in progress
  this.setState({ isModifyingSubscription: true });
  if(continueToSMS) {
   // Update the phone number as done in ViewVenueSubscribers.js
   this.updateSubscriberPhoneNumber();
  }else{
   // Create a fake event object to match the existing submitHandler expectations
   const fakeEvent = {
    preventDefault: () => { },
    target: {
     className: "needs-validation"
    }
   };
   // Call the existing submit handler
   this.submitHandler(fakeEvent);
  }
  // Note: SMS modal will be shown in componentDidUpdate if continueToSMSAfterSave is true
  // after the submitModify operation completes
 };
 
 toggleEmailChangeConfirm = () => {
  this.setState({
   modalEmailChangeConfirm: !this.state.modalEmailChangeConfirm
  });
 };
 
 confirmEmailChange = () => {
  // Close the modal and proceed with save
  this.setState({ modalEmailChangeConfirm: false });
  this.proceedWithSave(this.state.continueToSMSAfterSave);
 };
 
 cancelEmailChange = () => {
  // Revert email to original and close modal
  this.setState({ 
   email: this.state.originalEmail,
   modalEmailChangeConfirm: false 
  });
 };
 updateSubscriberPhoneNumber = () => {
  // Update the phone number as done in ViewVenueSubscribers.js submitModify function
  // This mimics the bodyUpdatePII logic from ViewVenueSubscribers.js
  let bodyUpdatePII = {
   AccessToken: sessionStorage.getItem("AccessToken"),
   IdToken: sessionStorage.getItem("IdToken"),
   EmailAddress: this.state.email,
   GivenName: this.state.firstName,
   FamilyName: this.state.lastName,
   "PhoneNumber.E164": this.state.phoneNumber,
   locale: this.state.selectedLanguage,
   contactpref_email: this.state.contactpref_email,
   contactpref_sms: this.state.contactpref_sms,
   VenueID: this.state.venueID,
   SubscriberToken: this.state.subscriberToken,
  };
  // Send the update request as done in ViewVenueSubscribers.js
  axios
   .post("/networkoperatorconsole/subscribers/updateSubscriberPII", bodyUpdatePII, {
    headers: {},
   })
   .then((response) => {
    console.log("Phone number updated successfully");
    this.props.getVenueDetails(this.state.venueID);
    // Update the local state to reflect the successful phone number update
    this.setState({
     originalPhoneNumber: this.state.phoneNumber,
     phoneNumberUpdated: false,
     isModifyingSubscription: false
    });
   })
   .catch((error) => {
    toast.error(error.response.data.message, {
                        closeButton: false,
                    });
    this.setState({
     phoneNumberUpdated: true,
     isModifyingSubscription: false,
    });
   });
 };
 render() {
  console.log('ModifyResident props:', this.state);
  sessionStorage.setItem("stripeClientSecretSubscriber", this.props.StripeClientSecret);
  sessionStorage.setItem("unitID_internalSubscriber", this.props.unitID_internal);
  sessionStorage.setItem("servicePlanIDSubscriber", this.props.servicePlanID);
  sessionStorage.setItem("newServicePlanID", this.props.servicePlanID);
  sessionStorage.setItem("emailSubscriber", this.props.email);
  sessionStorage.setItem("dateStart", this.props.startDate);
  const { t } = this.props;
  const FORMAT = "MM/dd/yyyy";
  let showTransactions;
  brandsData.forEach(({ name, url, cancel_input_type, phone_number, flag_update, flag_showTransactions }) => {
   if (url.includes(window.location.hostname)) {
    showTransactions = flag_showTransactions;
   }
  });
  
  // Check if this venue requires special character
  const specialCharVenues = [
    "USA.AZ.85004.MEREONETWORKSMANAGEDPROPERTIES.PHOENIX._V3VENUE_.USA.AZ.85251.THEGLENATOLDTOWN.SCOTTSDALE",
    "USA.AZ.85004.MEREONETWORKSMANAGEDPROPERTIES.PHOENIX._V3VENUE_.USA.AZ.85251.VISCONTIATCAMELBAC.SCOTTSDALE",
    "USA.AZ.85004.MEREONETWORKSMANAGEDPROPERTIES.PHOENIX._V3VENUE_.USA.AZ.85251.THECORTESIAN.SCOTTSDALE",
    "USA.AZ.85004.MEREONETWORKSMANAGEDPROPERTIES.PHOENIX._V3VENUE_.USA.AZ.85004.CORTECAALTIPLANOTE.PHOENIX",
                  "USA.AZ.85004.MEREONETWORKSMANAGEDPROPERTIES.PHOENIX._V3VENUE_.USA.WI.53158.INSPIREPRAIRIESPRI.PLEASANTP"
  ]
  const requiresSpecialChar = specialCharVenues.includes(this.props.venueID);
  // Maximum count is 6 if special char required (number, lowercase, uppercase, special, charLength, API validation)
  // Maximum count is 5 if no special char (number, lowercase, uppercase, charLength, API validation)
  const maxCount = requiresSpecialChar ? 6 : 5;
  
  let passwordStrength;
  const percentage = (this.state.count / maxCount) * 100;
  if (percentage <= 40) {
   passwordStrength = "weak"
  } else if (percentage > 40 && percentage < 80) {
   passwordStrength = "average"
  } else {
   passwordStrength = "strong"
  }
  // Resolve the current (possibly degraded) service plan name from its ID
  let currentServicePlanName = "";
  if (this.state.currentServicePlanID && this.state.availablePlans) {
   const matchedPlan = Object.values(this.state.availablePlans).find(
    (plan) => plan["ServicePlanID"] === this.state.currentServicePlanID
   );
   currentServicePlanName = matchedPlan ? matchedPlan["ServicePlanName"] : "";
  }
  return (
   <>
    {/* Loading overlay for subscription modification */}
    {this.state.isModifyingSubscription && (
     <div className="overlay" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999
     }}>
      <div style={{
       backgroundColor: 'white',
       padding: '20px',
       borderRadius: '8px',
       textAlign: 'center',
       boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
      }}>
       <div className="spinner-border spinner-border-lg text-primary" role="status">
        <span className="sr-only">Loading...</span>
       </div>
       <p className="mt-3 mb-0">Modifying subscription...</p>
      </div>
     </div>
    )}
    {/* Initial loading overlay for component mount data fetching */}
    {this.state.isInitialLoading && (
     <div className="overlay" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999
     }}>
      <div style={{
       backgroundColor: 'white',
       padding: '30px',
       borderRadius: '12px',
       textAlign: 'center',
       boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
       minWidth: '320px',
       maxWidth: '400px'
      }}>
       <div className="spinner-border spinner-border-lg text-primary mb-3" role="status">
        <span className="sr-only">Loading...</span>
       </div>
       <h5 className="mb-3" style={{ color: '#333', fontWeight: '600' }}>Loading Resident Data</h5>
       <div className="progress mb-3" style={{ height: '8px', backgroundColor: '#f0f0f0' }}>
        <div
         className="progress-bar bg-primary"
         role="progressbar"
         style={{ width: `${this.state.loadingProgress}%`, transition: 'width 0.3s ease' }}
         aria-valuenow={this.state.loadingProgress}
         aria-valuemin="0"
         aria-valuemax="100"
        ></div>
       </div>
       <div style={{ fontSize: '14px', color: '#666' }}>
        <div className="mb-2">
         <span className={this.state.loadingStates.venueDetails ? 'text-success' : 'text-muted'}>
          {this.state.loadingStates.venueDetails ? '✓' : '○'} Venue Details
         </span>
        </div>
        <div className="mb-2">
         <span className={this.state.loadingStates.messages ? 'text-success' : 'text-muted'}>
          {this.state.loadingStates.messages ? '✓' : '○'} Messages
         </span>
        </div>
        <div className="mb-2">
         <span className={this.state.loadingStates.subscriberKeys ? 'text-success' : 'text-muted'}>
          {this.state.loadingStates.subscriberKeys ? '✓' : '○'} Subscriber Keys
         </span>
        </div>
        <div className="mb-2">
         <span className={this.state.loadingStates.transactions ? 'text-success' : 'text-muted'}>
          {this.state.loadingStates.transactions ? '✓' : '○'} Transactions
         </span>
        </div>
        <div>
         <span className={this.state.loadingStates.logs ? 'text-success' : 'text-muted'}>
          {this.state.loadingStates.logs ? '✓' : '○'} System Logs
         </span>
        </div>
       </div>
       <p className="mt-3 mb-0" style={{ fontSize: '12px', color: '#999' }}>
        {Math.round(this.state.loadingProgress)}% Complete
       </p>
      </div>
     </div>
    )}
    <MDBModal isOpen={this.state.modalDeviceDetails} toggle={this.toggle} size="lg" className="form">
     <DeviceDetails toggleDeviceDetails={this.toggleDeviceDetailsClose} deviceDetails={this.state.deviceDetails} listKeys={this.props.listKeys} />
    </MDBModal>
    <MDBModal isOpen={this.state.modalCancel} toggle={this.toggleCancel}>
     <MDBModalHeader toggle={this.toggleCancel}>Cancel Service</MDBModalHeader>
     <MDBModalBody>
      <MDBContainer className="Form" fluid></MDBContainer>
     </MDBModalBody>
    </MDBModal>
    {this.state.toggleConfirm ? (
     <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg">
      <MDBModalHeader toggle={this.toggle}>Confirm Deletion</MDBModalHeader>
      <MDBModalBody>
       <p>Name: {this.state.firstName + " " + this.state.lastName}</p>
       <p>Email: {this.state.email}</p>
       <p>Unit: {this.state.unitID}</p>
       <p>Building: {this.state.building}</p>
       <p>Floor: {this.state.floor}</p>
       <>
        <div className="FormContainer">
         <div className="loginDisclosure">
          {showTransactions && window.location.pathname === "/networkdashboard" ? (
           <>
            <MDBRow>
             <MDBCol lg="6" sm="12">
              <label htmlFor="defaultFormLoginEmailEx" className="black-text">
               Last Invoice Date
              </label>
              <DateInput
               dateFormat="MM/DD/YYYY"
               name="endRequestDate"
               placeholder="MM/DD/YYYY"
               initialDate={this.state.mostRecentInvoice ? new Date(this.state.mostRecentInvoice) : null}
               value={this.state.mostRecentInvoice ? new Date(this.state.mostRecentInvoice) : null}
               iconPosition="left"
               onChange={this.changeHandlerRefundEndDate}
               onKeyDown={this.preventDateKeyboardInput}
               className="dateTimePicker"
               maxDate={this.state.billingCycleEnd ? new Date(this.state.billingCycleEnd) : null}
               minDate={this.state.invoiceDate ? new Date(this.state.invoiceDate) : null}
               closable={true}
               disabled={true}
              />
             </MDBCol>
             <MDBCol lg="6" sm="12">
              <label htmlFor="defaultFormLoginEmailEx" className="black-text">
               Refund Date (price calculated from this date)
              </label>
              <DateInput
               dateFormat="MM/DD/YYYY"
               name="endRequestDate"
               placeholder="MM/DD/YYYY"
               initialDate={this.state.billingCycleEnd ? new Date(this.state.billingCycleEnd) : null}
               value={this.state.endRequestDate ? new Date(this.state.endRequestDate) : null}
               iconPosition="left"
               onChange={this.changeHandlerRefundEndDate}
               onKeyDown={this.preventDateKeyboardInput}
               className="dateTimePicker"
               maxDate={this.state.billingCycleEnd ? new Date(this.state.billingCycleEnd) : null}
               minDate={this.state.invoiceDate ? new Date(this.state.invoiceDate) : null}
               closable={true}
               disabled={this.state.transactions.length === 0 ? true : false}
              />
             </MDBCol>
            </MDBRow>
            <br />
            <label htmlFor="defaultFormLoginEmailEx" className="black-text">
             Refund Amount
            </label>
            <br />
            <span className="currencySymbol">{this.state.currencySymbol}</span>
            <input
             type="number"
             id="refundAmount"
             name="refundAmount"
             className="form-control refundAmount"
             value={this.state.refundAmount === 0 ? this.state.refundAmount.toFixed(2) : this.state.refundAmount}
             min="0"
             max={this.state.refundAmountMax}
             onChange={this.changeHandler}
             step=".01"
             disabled={this.state.transactions.length === 0 ? true : false}
            />
            <div className="invalid-feedback">Refund amount cannot be more than paid amount</div>
            <br />
           </>
          ) : (
           ""
          )}
          <p className="pb-0 mb-0">Reason for Deletion:</p>
          {sessionStorage.getItem("cancelInputType") === "checkbox" ? (
           <>
            <MDBRow>
             <MDBCol col="12" className="leftAlign agree">
              <MDBInput required label="Moving" type="checkbox" id="moving" name="Moving" onChange={this.changeHandlerCheckbox} checked={this.state.moving} />
             </MDBCol>
            </MDBRow>
            <MDBRow>
             <MDBCol col="12" className="leftAlign agree">
              <MDBInput label="Price" type="checkbox" id="price" name="Price" onChange={this.changeHandlerCheckbox} checked={this.state.price} />
             </MDBCol>
            </MDBRow>
            <MDBRow>
             <MDBCol col="12" className="leftAlign agree">
              <MDBInput label="Poor customer service" type="checkbox" id="poorCustomerService" name="Poor Customer Service" onChange={this.changeHandlerCheckbox} checked={this.state.poorCustomerService} />
             </MDBCol>
            </MDBRow>
            <MDBRow>
             <MDBCol col="12" className="leftAlign agree">
              <MDBInput label="Received a competitor promo" type="checkbox" id="receivedPromo" name="Received Promo" onChange={this.changeHandlerCheckbox} checked={this.state.receivedPromo} />
             </MDBCol>
            </MDBRow>
            <MDBRow>
             <MDBCol col="12" className="leftAlign agree">
              <MDBInput label="My promo expired" type="checkbox" id="promoExpired" name="Promo Expired" onChange={this.changeHandlerCheckbox} checked={this.state.promoExpired} />
             </MDBCol>
            </MDBRow>
            <MDBRow>
             <MDBCol col="12" className="leftAlign agree">
              <MDBInput label="Reliability" type="checkbox" id="reliability" name="Reliability" onChange={this.changeHandlerCheckbox} checked={this.state.reliability} />
             </MDBCol>
            </MDBRow>
            <MDBRow>
             <MDBCol col="12" className="leftAlign agree">
              <MDBInput label="Speeds" type="checkbox" id="speeds" name="Speeds" onChange={this.changeHandlerCheckbox} checked={this.state.speeds} />
             </MDBCol>
            </MDBRow>
            <MDBRow>
             <MDBCol col="12" className="leftAlign agree">
              <MDBInput label="Order Error/Incorrect Sign-Up" type="checkbox" id="orderError" name="Order Error/Incorrect Sign-Up" onChange={this.changeHandlerCheckbox} checked={this.state.orderError} />
             </MDBCol>
            </MDBRow>
           </>
          ) : (
           <>
            <MDBRow>
             <MDBCol col="12" className="leftAlign agree">
              <MDBInput label="Moving" type="radio" id="moving" name="Moving" onChange={this.changeHandlerRadio("Moving")} checked={this.state.radio === "Moving" ? true : false} />
             </MDBCol>
            </MDBRow>
            <MDBRow>
             <MDBCol col="12" className="leftAlign agree">
              <MDBInput label="Price" type="radio" id="price" name="Price" onChange={this.changeHandlerRadio("Price")} checked={this.state.radio === "Price" ? true : false} />
             </MDBCol>
            </MDBRow>
            <MDBRow>
             <MDBCol col="12" className="leftAlign agree">
              <MDBInput label="Poor customer service" type="radio" id="poorCustomerService" name="Poor Customer Service" onChange={this.changeHandlerRadio("Poor Customer Service")} checked={this.state.radio === "Poor Customer Service" ? true : false} />
             </MDBCol>
            </MDBRow>
            <MDBRow>
             <MDBCol col="12" className="leftAlign agree">
              <MDBInput label="Received a competitor promo" type="radio" id="receivedPromo" name="Received Promo" onChange={this.changeHandlerRadio("Received Promo")} checked={this.state.radio === "Received Promo" ? true : false} />
             </MDBCol>
            </MDBRow>
            <MDBRow>
             <MDBCol col="12" className="leftAlign agree">
              <MDBInput label="My promo expired" type="radio" id="promoExpired" name="Promo Expired" onChange={this.changeHandlerRadio("Promo Expired")} checked={this.state.radio === "Promo Expired" ? true : false} />
             </MDBCol>
            </MDBRow>
            <MDBRow>
             <MDBCol col="12" className="leftAlign agree">
              <MDBInput label="Reliability" type="radio" id="reliability" name="Reliability" onChange={this.changeHandlerRadio("Reliability")} checked={this.state.radio === "Reliability" ? true : false} />
             </MDBCol>
            </MDBRow>
            <MDBRow>
             <MDBCol col="12" className="leftAlign agree">
              <MDBInput label="Speeds" type="radio" id="speeds" name="Speeds" onChange={this.changeHandlerRadio("Speeds")} checked={this.state.radio === "Speeds" ? true : false} />
             </MDBCol>
            </MDBRow>
            <MDBRow>
             <MDBCol col="12" className="leftAlign agree">
              <MDBInput label="Order Error/Incorrect Sign-Up" type="radio" id="orderError" name="Order Error/Incorrect Sign-Up" onChange={this.changeHandlerRadio("Order Error/Incorrect Sign-Up")} checked={this.state.radio === "Order Error/Incorrect Sign-Up" ? true : false} />
             </MDBCol>
            </MDBRow>
           </>
          )}
         </div>
        </div>
       </>
       <div className="error-message">{this.state.cancelErrorMessage}</div>
      </MDBModalBody>
      <MDBModalFooter>
       <MDBBtn color="primary" onClick={this.submitDelete} disabled={this.state.loadingDelete === true}>
        {this.state.loadingDelete === true ? (
         <div className="spinner-border spinner-border-sm" role="status">
          <span className="sr-only">Loading...</span>
         </div>
        ) : (
         "Confirm"
        )}
       </MDBBtn>
       <MDBBtn color="primary" onClick={this.toggle}>
        Close
       </MDBBtn>
      </MDBModalFooter>
     </MDBModal>
    ) : null}
    <MDBModal isOpen={this.state.modalResendActivation} toggle={this.toggle}>
     <MDBModalHeader toggle={this.toggleResendActivation}>Resend Activation</MDBModalHeader>
     <MDBModalBody>
      {sessionStorage.getItem("SMSEnabled") === "true" && (
        <MDBBtn className="float-right" color="primary" onClick={this.handleResendSMSClick} disabled={this.state.phoneNumber === undefined || this.state.phoneNumber === ""}>
         {this.state.loadingResendSMS === true ? (
          <div className="spinner-border spinner-border-sm" role="status">
           <span className="sr-only">Loading...</span>
          </div>
         ) : (
          "Resend by SMS"
         )}
        </MDBBtn>
      )}
      <MDBBtn className="float-right" color="primary" onClick={this.submitHandlerResendActivationEmail} disabled={!this.state.contactpref_email}>
       {this.state.loadingResend === true ? (
        <div className="spinner-border spinner-border-sm" role="status">
         <span className="sr-only">Loading...</span>
        </div>
       ) : (
        "Resend by Email"
       )}
      </MDBBtn>
     </MDBModalBody>
    </MDBModal>
    <MDBModal isOpen={this.state.modalResendActivationSMSConfirm} toggle={this.toggle}>
     <MDBModalHeader toggle={this.toggleResendActivationSMSConfirm}>Resend Activation Confirmation</MDBModalHeader>
     <MDBModalBody>
      <p>Before sending this SMS, confirm that the customer has clearly agreed to receive a one-time message for the stated purpose.</p>
      <MDBInput label={`I confirm that the customer gave explicit verbal consent to receive a one-time SMS message related to this support interaction at ${this.formatPhoneNumber(this.state.phoneNumber)}. This message will not re-enroll the customer in SMS communications.`} type="checkbox" id="resendSMSConfirmOne" name="resendSMSConfirmOne" onChange={this.toggleCheckboxValueSMSConfirmOne} checked={this.state.resendSMSConfirmOne} />
      <MDBInput label="I have informed the customer that this is a one-time message and that they will not receive further SMS unless they opt in separately." type="checkbox" id="resendSMSConfirmTwo" name="resendSMSConfirmTwo" onChange={this.toggleCheckboxValueSMSConfirmTwo} checked={this.state.resendSMSConfirmTwo} />
      <MDBBtn className="float-right mt-4" color="primary" onClick={this.submitHandlerResendActivationSMS} disabled={!this.state.resendSMSConfirmOne || !this.state.resendSMSConfirmTwo}>
       {this.state.loadingResendSMS === true ? (
        <div className="spinner-border spinner-border-sm" role="status">
         <span className="sr-only">Loading...</span>
        </div>
       ) : (
        "Resend Activation"
       )}
      </MDBBtn>
     </MDBModalBody>
    </MDBModal>
    {/* Phone Number Update Required Modal */}
    <MDBModal isOpen={this.state.modalPhoneNumberUpdateRequired} toggle={this.togglePhoneNumberUpdateRequired}>
     <MDBModalHeader toggle={this.togglePhoneNumberUpdateRequired}>
      <MDBIcon icon="exclamation-triangle" className="mr-2" style={{ color: '#ff6b6b' }} />
      Phone Number Updated
     </MDBModalHeader>
     <MDBModalBody>
      <div className="mb-3">
       <MDBIcon icon="info-circle" className="mr-2" style={{ color: '#007bff' }} />
       <strong>It looks like you have updated the subscriber's phone number.</strong>
      </div>
      <p className="mb-3">
       This SMS can only be sent to the number associated to the subscriber's account.
       Please click <strong>Save</strong> to update the subscriber's phone number.
      </p>
      <div className="alert alert-info" style={{ backgroundColor: '#e7f3ff', border: '1px solid #b3d9ff', borderRadius: '4px', padding: '12px' }}>
       <strong>Current phone number:</strong> {this.formatPhoneNumber(this.state.phoneNumber)}
      </div>
     </MDBModalBody>
     <MDBModalFooter>
      <MDBBtn color="primary" onClick={this.handleSaveAndContinueSMS}>
       {this.state.isModifyingSubscription ? (
        <div className="spinner-border spinner-border-sm mr-2" role="status">
         <span className="sr-only">Loading...</span>
        </div>
       ) : null}
       Save
      </MDBBtn>
      <MDBBtn color="primary" onClick={this.togglePhoneNumberUpdateRequired}>
       Cancel
      </MDBBtn>
     </MDBModalFooter>
    </MDBModal>
    <MDBModal isOpen={this.state.modalMoveVenue} toggle={this.toggleMoveVenue} size="lg">
     <MDBModalHeader toggle={this.toggleMoveVenue}>
      Move Subscription to Another Venue
     </MDBModalHeader>
     <MDBModalBody>
      <div className="alert mb-4" style={{backgroundColor: 'white', border: '2px solid #007bff', borderRadius: '4px', padding: '1rem'}}>
       <MDBIcon icon="info-circle" className="mr-2" style={{color: '#007bff'}} />
       <strong>Current Subscription:</strong>
       <div className="mt-2">
        <div><strong>Subscriber:</strong> {this.state.firstName} {this.state.lastName}</div>
        <div><strong>Venue:</strong> {this.state.venueName || this.props.venueName || "Current Venue"}</div>
        <div><strong>Unit:</strong> {this.state.unitID}</div>
        <div><strong>Service Plan:</strong> {
         (() => {
          const selectedPlan = this.state.optionTemplateServicePlan?.find(plan => plan.value === this.state.selectedServicePlanIndex);
          return selectedPlan?.name || this.props.servicePlan || this.state.selectedServicePlan || "N/A";
         })()
        }</div>
       </div>
      </div>
      
      <MDBRow>
       <MDBCol sm="12">
        <label className="black-text">
         <strong>Select Destination Venue:</strong>
        </label>
        <select
         className="browser-default custom-select"
         style={{backgroundColor: 'white'}}
         value={this.state.selectedDestinationVenue}
         onChange={this.handleDestinationVenueChange}
        >
         <option value="">Select a venue...</option>
         {this.state.venues && this.state.venues.map((venue, index) => (
          <option key={index} value={venue.VenueID}>
           {venue.VenueName}
          </option>
         ))}
        </select>
       </MDBCol>
      </MDBRow>
      
      {this.state.selectedDestinationVenue && (
       <MDBRow className="mt-3">
        <MDBCol sm="12">
         <label className="black-text">
          <strong>Select Destination Unit:</strong>
         </label>
         <select
          className="browser-default custom-select"
          style={{backgroundColor: 'white'}}
          value={this.state.selectedDestinationUnit}
          onChange={(e) => this.setState({ selectedDestinationUnit: e.target.value })}
         >
          <option value="">Select a unit...</option>
          {this.state.destinationVenueUnits && this.state.destinationVenueUnits.map((unit, index) => (
           <option key={index} value={unit.UnitID_internal}>
            {unit.UnitID} {unit.Building ? `- ${unit.Building}` : ""} {unit.Floor ? `Floor ${unit.Floor}` : ""}
           </option>
          ))}
         </select>
        </MDBCol>
       </MDBRow>
      )}
      
      <div className="alert alert-warning mt-4">
       <MDBIcon icon="exclamation-triangle" className="mr-2" />
       <strong>Warning:</strong> This will end the current subscription and create a new subscription at the destination venue/unit. 
       The subscriber’s service plan and personal profile will be preserved. If the subscriber has a payment method on file, they will need to re-enter their payment information upon login. The destination venue must have the same service plan available.
      </div>
     </MDBModalBody>
     <MDBModalFooter>
      <MDBBtn 
       color="danger" 
       onClick={this.submitMoveVenue}
       disabled={!this.state.selectedDestinationVenue || !this.state.selectedDestinationUnit || this.state.loadingMoveVenue}
      >
       {this.state.loadingMoveVenue ? (
        <>
         <div className="spinner-border spinner-border-sm mr-2" role="status">
          <span className="sr-only">Loading...</span>
         </div>
         Moving...
        </>
       ) : (
        "Confirm Move"
       )}
      </MDBBtn>
      <MDBBtn color="primary" onClick={this.toggleMoveVenue} disabled={this.state.loadingMoveVenue}>
       Cancel
      </MDBBtn>
     </MDBModalFooter>
    </MDBModal>
    <MDBModal isOpen={this.state.modalEmailChangeConfirm} toggle={this.toggleEmailChangeConfirm} size="md">
     <MDBModalHeader toggle={this.toggleEmailChangeConfirm}>
      <MDBIcon icon="exclamation-triangle" className="mr-2" style={{color: '#ff9800'}} />
      Confirm Email Address Change
     </MDBModalHeader>
     <MDBModalBody>
      <div className="alert alert-warning" style={{backgroundColor: '#fff3cd', border: '1px solid #ffc107', borderRadius: '4px', padding: '1rem'}}>
       <MDBIcon icon="info-circle" className="mr-2" style={{color: '#856404'}} />
       <strong>Important Notice:</strong>
       <p className="mt-2 mb-0">
        You are about to edit the subscriber's e-mail address. Please note, upon completing this action the subscriber will have to use the new e-mail address to log in to VAULT.
       </p>
      </div>
      
      <div className="mt-4" style={{backgroundColor: '#f8f9fa', padding: '1rem', borderRadius: '4px', border: '1px solid #dee2e6'}}>
       <MDBRow>
        <MDBCol sm="12">
         <div className="mb-3">
          <strong style={{color: '#495057'}}>Current Email Address:</strong>
          <div className="mt-1" style={{fontSize: '16px', color: '#212529', fontFamily: 'monospace', padding: '0.5rem', backgroundColor: 'white', border: '1px solid #ced4da', borderRadius: '4px'}}>
           {this.state.originalEmail}
          </div>
         </div>
        </MDBCol>
       </MDBRow>
       <MDBRow>
        <MDBCol sm="12">
         <div>
          <strong style={{color: '#495057'}}>New Email Address:</strong>
          <div className="mt-1" style={{fontSize: '16px', color: '#212529', fontFamily: 'monospace', padding: '0.5rem', backgroundColor: 'white', border: '1px solid #ced4da', borderRadius: '4px'}}>
           {this.state.email}
          </div>
         </div>
        </MDBCol>
       </MDBRow>
      </div>
      
      <div className="mt-3" style={{fontSize: '14px', color: '#6c757d'}}>
       <MDBIcon icon="lightbulb" className="mr-2" />
       The subscriber will receive a notification about this change and must use the new email address for future logins.
      </div>
     </MDBModalBody>
     <MDBModalFooter>
      <MDBBtn 
       color="danger" 
       onClick={this.confirmEmailChange}
      >
       <MDBIcon icon="check" className="mr-2" />
       Confirm Email Change
      </MDBBtn>
      <MDBBtn color="primary" onClick={this.cancelEmailChange}>
       <MDBIcon icon="times" className="mr-2" />
       Cancel
      </MDBBtn>
     </MDBModalFooter>
    </MDBModal>
    <MDBModal isOpen={this.state.modalConfirmRemoveKey} toggle={this.toggle}>
     <MDBModalHeader toggle={this.toggleConfirmRemoveKey}>Confirm Removal of Key</MDBModalHeader>
     <MDBModalBody>
      <p>SSID: {this.state.keySSID}</p>
      <p>Keytag: {this.state.keytag}</p>
     </MDBModalBody>
     <MDBModalFooter>
      <MDBBtn color="primary" onClick={this.submitRemoveKey}>
       {this.state.loadingRemoveKey === true ? (
        <div className="spinner-border spinner-border-sm" role="status">
         <span className="sr-only">Loading...</span>
        </div>
       ) : (
        "Confirm"
       )}
      </MDBBtn>
      <MDBBtn color="primary" onClick={this.toggleConfirmRemoveKey}>
       Close
      </MDBBtn>
     </MDBModalFooter>
    </MDBModal>
    <MDBModal isOpen={this.state.modalShowWifiPassword} toggle={this.closeShowWifiPassword}>
     <MDBModalBody>
      <p>You are about to view a user's Wi-Fi password. This event will be logged and reviewed.</p>
      <MDBBtn color="primary" onClick={this.toggleConfirmShowWifiPassword}>
       Show Password
      </MDBBtn>
      <MDBBtn color="primary" onClick={this.closeShowWifiPassword}>
       Close
      </MDBBtn>
     </MDBModalBody>
    </MDBModal>
    <MDBModal isOpen={this.state.modalConfirmShowWifiPassword} toggle={this.toggleConfirmShowWifiPassword}>
     <MDBModalHeader toggle={this.toggleConfirmShowWifiPassword}>Wi-Fi Password</MDBModalHeader>
     <MDBModalBody>
      <p id="password">{this.state.subcriberWifiPassword}</p>
      <br />
      <MDBBtn color="primary" onClick={this.togglePSKValidator}>
       Test PSK
      </MDBBtn>
      <MDBBtn color="primary" onClick={this.toggleConfirmShowWifiPassword}>
       Close
      </MDBBtn>
     </MDBModalBody>
    </MDBModal>
    <MDBModal isOpen={this.state.modalChangeWifiPassword} toggle={this.toggleChangeWifiPassword} size="lg" className="form">
     <MDBModalHeader toggle={this.toggleChangeWifiPassword}>
      <h4>Edit Password</h4>
     </MDBModalHeader>
     <MDBModalBody>
      <MDBRow>
       <MDBCol col="6">
        <p>WARNING</p>
        <p>Devices connected to this network will need to be reconfigured with the new password. Your old password will remain active for two hours. Upon expiration, devices using that password will lose the Wi-Fi connection.</p>
        <p>Please note, it will take up to 5 minutes for the new Wi-Fi password to activate and take effect.</p>
        <div className="form-group row">
         <div className="col-sm-2">
          <p>Profile</p>
         </div>
         <div className="col-sm-6">{this.state.selectedKeyName}</div>
        </div>
        <div className="form-group row">
         <div className="col-sm-2">
          <p>Network</p>
         </div>
         <div className="col-sm-6">{this.state.ssidName}</div>
        </div>
        {
         sessionStorage.getItem("showCustomPSK") === "false"
          ?
          <>
           <p className="wifiDisclaimer">Enter a new Personal Token below. Your Wi-Fi password is the combination of your personal token and your unique ID. For security purposes, the unique ID cannot be modified.</p>
           <label
            htmlFor="defaultFormLoginEmailEx"
            className="black-text passwordLabel"
           >
            Wi-Fi Password
           </label>
           <input
            id="editpassword"
            className="form-control"
            onChange={(e) => this.setPassword(e.target.value, this.state.subcriberWifiPassword)}
            name="password"
            value={this.state.password === "." ? this.state.subcriberWifiPassword.split(".")[0] : this.state.password.split(".")[0]}
           />
           <span className="password_subscriber">
            .
            {
             this.state.subscriberToken
            }
           </span>
           <div className="invalid-feedback">
            Please provide a valid password.
           </div>
           <br />
           <br />
           <p>New Wi-Fi Password</p>
           <input
            id="editpassword2"
            className="form-control"
            onChange={this.changeHandler}
            name="password"
            value={
             this.state.newpsk !== ""
              ? this.state.newpsk +
              "." +
              this.state.subscriberToken
              : this.state.subcriberWifiPassword.split(".")[0] +
              "." +
              this.state.subscriberToken
            }
           />
          </>
          :
          <MDBRow>
           <MDBCol className="col-auto pr-3 editPassword">
            <label
             htmlFor="defaultFormLoginEmailEx"
             className="black-text passwordLabel"
            >
             Old Wi-Fi Password
            </label>
            <input
             disabled
             id="editpassword"
             className="form-control"
             name="password"
             value={
              this.state.password ? this.state.subcriberWifiPassword : this.state.password
             }
            />
            <br />
            <label
             htmlFor="defaultFormLoginEmailEx"
             className="black-text passwordLabel"
            >
             New Wi-Fi Password
            </label>
            <input
             id="editpassword"
             className="form-control"
             onChange={(e) =>
              this.setPassword(
               e.target.value,
               this.state.newpsk !== undefined
                ? this.state.newpsk
                : this.state.newpsk
              )
             }
             name="password"
             value={
              this.state.newpsk
             }
            />
            <br />
            <LinearProgress
             value={this.state.count * 20}
             // valueBuffer="100"
             variant="determinate"
             className={passwordStrength}
            />
            Your password strength is {passwordStrength}
           </MDBCol>
           <MDBCol className="col-auto pl-1">
            {/* <label
                      htmlFor="defaultFormLoginEmailEx"
                      className="black-text passwordLabel"
                    >
                      Unique ID
                    </label>
                    <input
                      id="editpassword"
                      className="form-control"
                      disabled="true"
                      onChange={(e) =>
                        this.setPassword(
                          e.target.value,
                          this.state.newpsk !== null
                            ? this.state.newpsk.split(".")[1]
                            : this.state.newpsk
                        )
                      }
                      name="password"
                      value={
                        this.state.newpsk !== null
                          ? this.state.newpsk.split(".")[1]
                          : this.state.newpsk
                      }
                    /> */}
            <label
             htmlFor="defaultFormLoginEmailEx"
             className="black-text passwordLabel bold"
            >
             Password Requirements
            </label>
            <PasswordConditions
             id="editpassword"
             className="form-control"
             charLength={this.state.charLength}
             lowercase={this.state.lowercase}
             uppercase={this.state.uppercase}
             number={this.state.number}
             emailMatch={this.state.emailMatch}
             symbol={this.state.symbol}
             dot={this.state.dot}
             specialChar={this.state.specialChar}
             requiresSpecialChar={(() => {
              console.log("Render venueID:", this.props.venueID);
              const specialCharVenues = [
                "USA.AZ.85004.MEREONETWORKSMANAGEDPROPERTIES.PHOENIX._V3VENUE_.USA.AZ.85251.THEGLENATOLDTOWN.SCOTTSDALE",
                "USA.AZ.85004.MEREONETWORKSMANAGEDPROPERTIES.PHOENIX._V3VENUE_.USA.AZ.85251.VISCONTIATCAMELBAC.SCOTTSDALE",
                "USA.AZ.85004.MEREONETWORKSMANAGEDPROPERTIES.PHOENIX._V3VENUE_.USA.AZ.85251.THECORTESIAN.SCOTTSDALE",
                "USA.AZ.85004.MEREONETWORKSMANAGEDPROPERTIES.PHOENIX._V3VENUE_.USA.AZ.85004.CORTECAALTIPLANOTE.PHOENIX",
                  "USA.AZ.85004.MEREONETWORKSMANAGEDPROPERTIES.PHOENIX._V3VENUE_.USA.WI.53158.INSPIREPRAIRIESPRI.PLEASANTP"
              ];
              console.log("Render check result:", specialCharVenues.includes(this.props.venueID));
              return specialCharVenues.includes(this.props.venueID);
             })()}
            />
            {this.state.passwordInvalid ?
             <label
              htmlFor="defaultFormLoginEmailEx"
              className="passwordLabel bold invalidPassword"
              id="invalidPassword"
             >
              Our apologies, your chosen password is not valid. Please create a new password.
             </label>
             : ""}
           </MDBCol>
          </MDBRow>
        }
        {/* <label htmlFor="defaultFormLoginEmailEx" className="black-text passwordLabel">
                                    Wi-Fi Password
                                </label> */}
        {/* <input
                                    id="editpassword"
                                    className="form-control"
                                    onChange={(e) => this.setPassword(e.target.value, this.state.subcriberWifiPassword)}
                                    name="password"
                                    value={this.state.password === "." ? this.state.subcriberWifiPassword.split(".")[0] : this.state.password.split(".")[0]}
                                />
                                <span className="password_subscriber">.{this.state.subcriberWifiPassword.split(".")[1]}</span>
                                <div className="invalid-feedback">Please provide a valid password.</div>
                                <br />
                                <br />
                                <p>New Wi-Fi Password</p>
                                <input
                                    id="editpassword2"
                                    className="form-control"
                                    onChange={this.changeHandler}
                                    name="password"
                                    value={this.state.password === "." ? this.state.subcriberWifiPassword.split(".")[0] + "." + this.state.subcriberWifiPassword.split(".")[1] : this.state.password.split(".")[0] + "." + this.state.subcriberWifiPassword.split(".")[1]}
                                /> */}
       </MDBCol>
      </MDBRow>
      <div className="text-right submitButton">
       <MDBBtn color="danger" disabled={(passwordStrength !== "strong" && sessionStorage.getItem("showCustomPSK") === "true") || this.state.submittingPSKReset === true || this.state.newpsk === "" ? true : false} onClick={this.submitEditPassword}>
        Submit
       </MDBBtn>
       <MDBBtn color="danger" onClick={this.toggleChangeWifiPassword}>
        Cancel
       </MDBBtn>
      </div>
     </MDBModalBody>
    </MDBModal>
    {this.state.toggleAddKey ? (
     <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg">
      <AddKey
       keyPoolList={this.state.keyPoolList}
       venueName={this.state.venueName}
       venueID={this.state.venueID}
       email={this.state.email}
       firstName={this.state.firstName}
       lastName={this.state.lastName}
       phoneNumber={this.state.phoneNumber}
       UnitID_internal={this.props.unitID_internal}
       unitID={this.state.unitID}
       building={this.state.building}
       floor={this.state.floor}
       toggleAddKey={this.toggleAddKey}
       submitAddKey={this.submitAddKey}
       loadingAddKey={this.state.loadingAddKey}
      />
     </MDBModal>
    ) : null}
    {this.state.messageID !== undefined && this.state.messages && this.state.messages[this.state.messageID] ? (
     <MDBModal isOpen={this.state.modalMessage} toggle={this.toggle} centered>
      <MDBModalHeader toggle={this.toggle}>Messages</MDBModalHeader>
      <MDBModalBody>
       <MDBRow className="messageSubject">
        <MDBCol>
         <p>Subject:</p>
         {this.state.messages[this.state.messageID]["Subject"]}
        </MDBCol>
       </MDBRow>
       <MDBRow>
        <MDBCol>
         <p>Message:</p>
         {parse(this.state.messages[this.state.messageID]["Message"])}
        </MDBCol>
       </MDBRow>
      </MDBModalBody>
     </MDBModal>
    ) : (
     ""
    )}
    <MDBModal isOpen={this.state.modalMessageSend} toggle={this.toggleMessageSend} centered size="lg">
     <MDBModalHeader toggle={this.toggleMessageSend}>Send Message</MDBModalHeader>
     <MDBModalBody>
      <MDBRow>
       <MDBCol col="12">
        <label htmlFor="defaultFormLoginEmailEx" className="black-text">
         Subject
        </label>
        <input name="subject" id="subject" className="form-control" onChange={this.changeHandler} value={this.state.subject} />
       </MDBCol>
      </MDBRow>
      <MDBRow>
       <MDBCol col="6">
        <label htmlFor="exampleFormControlTextarea1">Message</label>
        <textarea className="form-control" id="emailMessage" name="emailMessage" rows="10" onChange={this.changeHandler} value={this.state.emailMessage}></textarea>
        {/* <Editor
									apiKey="gw4td27mfhpoc1zr4q0yxusw050fnnxz00us4j5645mz285d"
									value={this.state.emailMessage}
									outputFormat="html"
									init={{
										height: 300,
										menubar: true,
										plugins: [
											"advlist autolink lists link image charmap print preview anchor",
											"searchreplace visualblocks code fullscreen",
											"insertdatetime media table paste code help wordcount",
										],
										toolbar:
											"undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help | code | image |inserttable | cell row column | tableprops deletetable ",
									}}
									onEditorChange={this.handleEditorChange}
								/> */}
       </MDBCol>
      </MDBRow>
     </MDBModalBody>
     <MDBModalFooter>
      <MDBBtn color="primary" onClick={this.submitMessage}>
       {this.state.loadingMessages === true ? (
        <div className="spinner-border spinner-border-sm" role="status">
         <span className="sr-only">Loading...</span>
        </div>
       ) : (
        "Send"
       )}
      </MDBBtn>
     </MDBModalFooter>
    </MDBModal>
    <MDBModal isOpen={this.state.modalPSKValidator} toggle={this.toggle} size="lg" className="form" centered>
     <PSKValidator
      togglePSKValidator={this.togglePSKValidator}
      modalPSKValidator={this.state.modalPSKValidator}
      optionTemplateVenues={this.props.optionTemplateVenues}
      updateName={this.props.updateName}
      venueInfo={this.props.venueInfo}
      loadingVenueDetails={this.state.loadingVenueDetails}
      getVenues={this.getVenues}
      keyPoolList={this.state.keyPoolList}
      selectedVenue={this.state.venueID}
      venueName={this.state.venueName}
      nasID={this.state.nasID}
      keySSID={this.state.keySSID}
      keySSIDID={this.state.keySSIDID}
      psk={this.state.subcriberWifiPassword}
     />
    </MDBModal>
    <MDBModal isOpen={this.state.modalValidationRequirements} toggle={this.toggleValidationRequirements} size="lg">
     <MDBModalHeader toggle={this.toggleValidationRequirements}>
      <MDBIcon icon="exclamation-triangle" className="mr-2" style={{ color: '#ff6b6b' }} />
      Required Fields Missing
     </MDBModalHeader>
     <MDBModalBody>
      <p>The following fields are required before you can save changes:</p>
      <ul className="list-unstyled">
       {this.state.validationErrors.map((error, index) => (
        <li key={index} className="mb-2">
         <MDBIcon icon="times-circle" className="mr-2" style={{ color: '#ff6b6b' }} />
         {error}
        </li>
       ))}
      </ul>
      <p className="mt-3 text-muted">
       Please fill in all required fields and try again.
      </p>
     </MDBModalBody>
     <MDBModalFooter>
      <MDBBtn color="primary" onClick={this.toggleValidationRequirements}>
       OK
      </MDBBtn>
     </MDBModalFooter>
    </MDBModal>
    <MDBModal isOpen={this.state.modalRefund} toggle={this.toggleRefund} size="lg">
     <MDBModalHeader toggle={this.toggleRefund}>Refund Transaction or Issue Credit</MDBModalHeader>
     <MDBModalBody>
      <p>
       Original Invoice Date:{" "}
       {this.state.invoiceDateRefund !== undefined
        ? new Intl.DateTimeFormat("en-US", {
         year: "numeric",
         month: "2-digit",
         day: "2-digit",
        }).format(new Date(this.state.invoiceDateRefund))
        : ""}
      </p>
      <p>Amount: {this.state.currencySymbol + this.state.refundAmountMax}</p>
      <MDBNav className="nav-tabs">
       {this.isNetworkAdmin() ? (
        <MDBNavItem>
         <MDBNavLink link to="#" active={this.state.activeItemRefund === "1"} onClick={this.toggleTabRefund("1")} role="tabRefund">
          Credit
         </MDBNavLink>
        </MDBNavItem>
       ) : (
        ""
       )}
       <MDBNavItem>
        <MDBNavLink link to="#" active={this.state.activeItemRefund === "2"} onClick={this.toggleTabRefund("2")} role="tabRefund">
         Refund
        </MDBNavLink>
       </MDBNavItem>
      </MDBNav>
      <MDBTabContent className="" activeItem={this.state.activeItemRefund}>
       <MDBTabPane tabId="2" role="tabpanel">
        <label htmlFor="defaultFormLoginEmailEx" className="black-text">
         Date Range (select the dates that you want to credit)
        </label>
        <MDBRow>
         <MDBCol lg="6" sm="12">
          <DateInput
           dateFormat="MM/DD/YYYY"
           name="endRequestDate"
           placeholder="MM/DD/YYYY"
           initialDate={this.state.invoiceDateRefund ? new Date(this.state.invoiceDateRefund) : null}
           value={this.state.invoiceDateRefund ? new Date(this.state.invoiceDateRefund) : null}
           iconPosition="left"
           onChange={this.changeHandlerRefundEndDate}
           className="dateTimePicker"
           maxDate={this.state.billingCycleEnd ? new Date(this.state.billingCycleEnd) : null}
           minDate={this.state.invoiceDate ? new Date(this.state.invoiceDate) : null}
           closable={true}
           disabled={true}
          />
         </MDBCol>
         <MDBCol lg="6" sm="12">
          <label htmlFor="defaultFormLoginEmailEx" className="black-text">
           Refund Date (price calculated from this date)
          </label>
          <DateInput
           dateFormat="MM/DD/YYYY"
           name="endRequestDate"
           placeholder="MM/DD/YYYY"
           initialDate={this.state.billingCycleEnd ? new Date(this.state.billingCycleEnd) : null}
           value={this.state.endRequestDate ? new Date(this.state.endRequestDate) : null}
           iconPosition="left"
           onChange={this.changeHandlerRefundEndDate}
           className="dateTimePicker"
           maxDate={this.state.billingCycleEnd ? new Date(this.state.billingCycleEnd) : null}
           minDate={this.state.invoiceDate ? new Date(this.state.invoiceDate) : null}
           closable={true}
           disabled={this.state.transactions.length === 0 ? true : false}
          />
         </MDBCol>
        </MDBRow>
        <br />
        <label htmlFor="defaultFormLoginEmailEx" className="black-text">
         Refund Amount
        </label>
        <br />
        <span className="currencySymbol">{this.state.currencySymbol}</span>
        <input
         type="number"
         id="refundAmount"
         name="refundAmount"
         className="form-control refundAmount"
         value={this.state.refundAmount === 0 ? this.state.refundAmount.toFixed(2) : this.state.refundAmount}
         min="0"
         max={this.state.refundAmountMax}
         onChange={this.changeHandler}
         step=".01"
         disabled={this.state.transactions.length === 0 ? true : false}
        />
        <div className="invalid-feedback">Refund amount cannot be more than paid amount</div>
        <br />
        <label htmlFor="exampleFormControlTextarea1">Memo</label>
        <textarea className="form-control" id="refundMemo" name="refundMemo" rows="5" onChange={this.changeHandler} />
        <MDBBtn color="danger" onClick={this.submitRefund}>
         {this.state.submittingRefund ? (
          <div className="spinner-border spinner-border-sm" role="status">
           <span className="sr-only">Loading...</span>
          </div>
         ) : (
          "Submit"
         )}
        </MDBBtn>
       </MDBTabPane>
       {this.isNetworkAdmin() ? (
       <MDBTabPane tabId="1" role="tabpanel">
        <label htmlFor="defaultFormLoginEmailEx" className="black-text">
         Date Range (select the dates that you want to credit)
        </label>
        <MDBRow>
         <MDBCol lg="6" sm="12">
          <DateInput
           dateFormat="MM/DD/YYYY"
           name="endRequestDate"
           placeholder="MM/DD/YYYY"
           initialDate={new Date(this.state.invoiceDateRefund)}
           value={new Date(this.state.invoiceDateRefund)}
           iconPosition="left"
           onChange={this.changeHandlerRefundEndDate}
           className="dateTimePicker"
           maxDate={new Date(this.state.billingCycleEnd)}
           minDate={new Date(this.state.invoiceDateRefund)}
           closable={true}
           disabled={true}
          />
         </MDBCol>
         <MDBCol lg="6" sm="12">
          <DateInput
           dateFormat="MM/DD/YYYY"
           name="endRequestDate"
           placeholder="MM/DD/YYYY"
           initialDate={new Date(this.state.billingCycleEnd)}
           value={new Date(this.state.endRequestDate)}
           iconPosition="left"
           onChange={this.changeHandlerRefundEndDate}
           className="dateTimePicker"
           maxDate={new Date(this.state.billingCycleEnd)}
           minDate={new Date(this.state.invoiceDateRefund)}
           closable={true}
          />
         </MDBCol>
        </MDBRow>
        <br />
        <label htmlFor="defaultFormLoginEmailEx" className="black-text">
         Credit Amount
        </label>
        <br />
        <span className="currencySymbol">{this.state.currencySymbol}</span>
        <input type="number" id="refundAmount" name="refundAmount" className="form-control refundAmount" value={this.state.refundAmount} min="0" max={this.state.refundAmountMax} onChange={this.changeHandler} step=".01" />
        <div className="invalid-feedback">Credit amount cannot be more than paid amount</div>
        <br />
        <label htmlFor="exampleFormControlTextarea1">Memo</label>
        <textarea className="form-control" id="refundMemo" name="refundMemo" rows="5" onChange={this.changeHandler} />
        <MDBBtn color="danger" onClick={this.submitCredit}>
         {this.state.submittingCredit ? (
          <div className="spinner-border spinner-border-sm" role="status">
           <span className="sr-only">Loading...</span>
          </div>
         ) : (
          "Submit"
         )}
        </MDBBtn>
       </MDBTabPane>
       ) : (
        ""
       )}
      </MDBTabContent>
     </MDBModalBody>
    </MDBModal>
    <MDBModalHeader toggle={this.props.toggleModifyResident}>
     <h4>Modify Resident</h4>
     {this.state.activeItem === "1" ? <p>{t("addnewresident.required")}</p> : ""}
    </MDBModalHeader>
    <MDBModalBody>
     <MDBNav className="nav-tabs">
      <MDBNavItem>
       <MDBNavLink link to="#" active={this.state.activeItem === "1"} onClick={this.toggleTab("1")} role="tab">
        <MDBIcon icon="user" /> Profile
       </MDBNavLink>
      </MDBNavItem>
      <MDBNavItem>
       <MDBNavLink link to="#" active={this.state.activeItem === "2"} onClick={this.toggleTab("2")} role="tab">
        <MDBIcon icon="envelope" /> Messages
       </MDBNavLink>
      </MDBNavItem>
      <MDBNavItem>
       <MDBNavLink link to="#" active={this.state.activeItem === "3"} onClick={this.toggleTab("3")} role="tab">
        <MDBIcon icon="chart-line" /> Bandwidth
       </MDBNavLink>
      </MDBNavItem>
      {window.location.pathname === "/networkdashboard" ? (
       <>
        <MDBNavItem>
         <MDBNavLink link to="#" active={this.state.activeItem === "4"} onClick={this.toggleTab("4")} role="tab">
          <MDBIcon icon="key" /> Keys
         </MDBNavLink>
        </MDBNavItem>
       </>
      ) : (
       ""
      )}
      {showTransactions ? (
       <>
        <MDBNavItem>
         <MDBNavLink link to="#" active={this.state.activeItem === "5"} onClick={this.toggleTab("5")} role="tab">
          <MDBIcon icon="shopping-cart" /> Transactions
         </MDBNavLink>
        </MDBNavItem>
       </>
      ) : (
       ""
      )}
      {window.location.pathname === "/networkdashboard" ? (
       <>
        <MDBNavItem>
         <MDBNavLink link to="#" active={this.state.activeItem === "6"} onClick={this.toggleTab("6")} role="tab">
          <MDBIcon icon="clipboard-list" /> Logs
         </MDBNavLink>
        </MDBNavItem>
        <MDBNavItem>
         <MDBNavLink link to="#" active={this.state.activeItem === "7"} onClick={this.toggleTab("7")} role="tab">
          <MDBIcon icon="laptop" /> Devices
         </MDBNavLink>
        </MDBNavItem>
        <MDBNavItem>
         <MDBNavLink link to="#" active={this.state.activeItem === "8"} onClick={this.toggleTab("8")} role="tab">
          <MDBIcon icon="database" /> System Data
         </MDBNavLink>
        </MDBNavItem>
       </>
      ) : (
       ""
      )}
     </MDBNav>
     <MDBTabContent className="" activeItem={this.state.activeItem}>
      <MDBTabPane tabId="1" role="tabpanel">
       <form className="needs-validation" onSubmit={(e) => e.preventDefault()} noValidate>
        <MDBRow>
         <MDBCol col="6" sm="12" lg="6">
          <label htmlFor="defaultFormLoginEmailEx" className="black-text">
           {t("addnewresident.email")}
          </label>
          <div className="residentEmail">
           <input
            disabled={
             window.location.pathname !== "/networkdashboard" || 
             sessionStorage.getItem("networkAdmin") <= 0 ||
             this.state.isModifyingSubscription || 
             (this.state.PMS?.SyncDateTimeUTC !== "" && this.state.subscriberManagedviaSSO !== false && this.state.subscriberManagedviaSSO !== undefined)
            }
            id="email"
            className="form-control"
            onBlur={(event) => this.validateEmail(this.state.email)}
            onChange={(event) =>
             this.setState({
              email: event.target.value,
             })
            }
            value={this.state.email}
           />
          </div>
          <div className="invalid-feedback">Please provide a valid email.</div>
         </MDBCol>
         <MDBCol sm="12" lg="6">
          <label htmlFor="defaultFormLoginEmailEx" className="black-text">
           Status
          </label>
          <input disabled id="status" className="form-control" value={this.state.status} />
         </MDBCol>
        </MDBRow>
        <MDBRow>
         <MDBCol sm="12" lg="6">
          <label htmlFor="defaultFormLoginEmailEx" className="black-text">
           {t("addnewresident.firstname")}
          </label>
          <input
           required
           disabled={this.state.isModifyingSubscription || (this.state.PMS?.SyncDateTimeUTC === "" && (this.state.subscriberManagedviaSSO === false || this.state.subscriberManagedviaSSO === undefined) ? false : true)}
           name="firstName"
           id="firstName"
           className={this.state.loading === true ? "form-control loading" : "form-control"}
           onChange={this.changeHandler}
           value={this.state.firstName}
          />
          <div className="invalid-feedback">Please provide a valid first name.</div>
         </MDBCol>
         <MDBCol sm="12" lg="6">
          <label htmlFor="defaultFormLoginEmailEx" className="black-text">
           {t("addnewresident.lastname")}
          </label>
          <input
           required
           disabled={this.state.isModifyingSubscription || (this.state.PMS?.SyncDateTimeUTC === "" && (this.state.subscriberManagedviaSSO === false || this.state.subscriberManagedviaSSO === undefined) ? false : true)}
           className={this.state.loading === true ? "form-control loading" : "form-control"}
           name="lastName"
           id="lastName"
           onChange={this.changeHandler}
           value={this.state.lastName}
          />
          <div className="invalid-feedback">Please provide a valid last name.</div>
         </MDBCol>
        </MDBRow>
        <MDBRow>
         <MDBCol col="6" sm="12" lg="6">
          <label htmlFor="defaultFormLoginEmailEx" className="black-text">
           {t("addnewresident.phone")}
          </label>
          <PhoneInput
           disabled={this.state.isModifyingSubscription || (this.state.PMS?.SyncDateTimeUTC === "" && (this.state.subscriberManagedviaSSO === false || this.state.subscriberManagedviaSSO === undefined) ? false : true)}
           placeholder={t("addnewresident.enterphone")}
           value={this.state.phoneNumber}
           format={FORMAT}
           onChange={this.changeHandlerPhone}
           name="phoneNumber"
           id="phoneNumber"
           className={this.state.invalidPhone ? "is-invalid form-control" : "form-control"}
           // className={this.state.loading === true ? "form-control loading" : "form-control"}
           defaultCountry="US"
          />
          {this.state.invalidPhone !== null ? <div className="invalid">{this.state.invalidPhone}</div> : ""}
         </MDBCol>
         <MDBCol col="6">
          <div>
           <label htmlFor="defaultFormLoginEmailEx" className="black-text">
            {t("addnewresident.language")}
           </label>
           <SelectSearch
            disabled={this.state.isModifyingSubscription || (this.state.PMS?.SyncDateTimeUTC === "" && (this.state.subscriberManagedviaSSO === false || this.state.subscriberManagedviaSSO === undefined) ? false : true)}
            id="selectLanguage"
            search={true}
            filterOptions={fuzzySearch}
            options={this.state.languageOptions}
            isOptionSelected={true}
            classNamePrefix="language-select"
            onChange={this.handleSelectChangeLanguage}
            value={this.state.selectedLanguage}
            placeholder={this.state.selectedLanguage !== undefined ? (this.state.selectedLanguage === "en-us" ? "English" : "Spanish") : "Select..."}
           />
           <div className="invalid-feedback">Please provide a valid language.</div>
          </div>
         </MDBCol>
        </MDBRow>
        <MDBRow>
         <MDBCol sm="12" lg="4">
          <label htmlFor="defaultFormLoginEmailEx" className="black-text">
           {t("addnewresident.unit")}
          </label>
          <SelectSearch
           disabled={this.state.isModifyingSubscription}
           id="selectUnit"
           options={this.state.optionTemplateUnits}
           search={true}
           filterOptions={fuzzySearch}
           onChange={this.handleSelectChangeUnit}
           isOptionSelected={true}
           inputId="buildingArray"
           classNamePrefix="unit-select"
           placeholder="Select..."
           value={this.state.unitID}
          />
          <div className="invalid-feedback">Please provide a unit number.</div>
         </MDBCol>
         <MDBCol sm="12" lg="4">
          <label htmlFor="defaultFormLoginEmailEx" className="black-text">
           {t("addnewresident.building")}
          </label>
          <SelectSearch
           disabled={this.state.isModifyingSubscription}
           id="selectBuilding"
           options={this.state.optionTemplateBuilding}
           search={true}
           filterOptions={fuzzySearch}
           onChange={this.handleSelectChangeBuilding}
           isOptionSelected={true}
           inputId="buildingArray"
           classNamePrefix="building-select"
           placeholder="Select..."
           value={this.state.selectedBuilding === undefined ? this.state.building : this.state.selectedBuilding}
          />
          <div className="invalid-feedback">Please provide a building.</div>
         </MDBCol>
         <MDBCol sm="12" lg="4">
          <label htmlFor="defaultFormLoginEmailEx" className="black-text">
           {t("addnewresident.floor")}
          </label>
          <SelectSearch
           disabled={this.state.isModifyingSubscription}
           ref={this.floorSelect}
           id="selectFloor"
           search={true}
           filterOptions={fuzzySearch}
           options={this.state.optionTemplateFloor}
           onChange={this.handleSelectChangeFloor}
           isOptionSelected={true}
           inputId="floorArray"
           classNamePrefix="floo-select"
           placeholder="Select..."
           emptyMessage="Select..."
           value={this.state.selectedFloor === undefined ? this.state.floor : this.state.selectedFloor}
          />
          <div className="invalid-feedback">Please provide a floor.</div>
         </MDBCol>
        </MDBRow>
        {this.state.PMS?.SyncDateTimeUTC !== "" ? (
          <>
            <MDBRow>
              {this.state.PMS?.EntrataUnitSpaceID && (
                <MDBCol col="6">
                  <label htmlFor="defaultFormLoginEmailEx" className="black-text">
                    Entrata Unit Space ID
                  </label>
                  <input disabled id="EntrataUnitSpaceID" className="form-control" value={this.state.PMS?.EntrataUnitSpaceID} />
                </MDBCol>
              )}
              {(this.state.PMS?.RealPageUnitID || this.state.RealPageUnitID) && (
                <MDBCol col="6">
                  <label htmlFor="defaultFormLoginEmailEx" className="black-text">
                    RealPage Unit ID
                  </label>
                  <input disabled id="RealPageUnitID" className="form-control" value={this.state.PMS?.RealPageUnitID || this.state.RealPageUnitID} />
                </MDBCol>
              )}
              <MDBCol col="6">
                <label htmlFor="defaultFormLoginEmailEx" className="black-text">
                  {this.state.PMS?.EntrataUnitSpaceID
                    ? "Last sync with Entrata"
                    : (this.state.PMS?.RealPageUnitID || this.state.RealPageUnitID)
                      ? "Last sync with RealPage"
                      : "Last sync with PMS"}
                </label>
                <input
                  disabled
                  id="PMSSyncDateUTC"
                  className="form-control"
                  value={
                    this.state.PMS?.SyncDateTimeUTC && !isNaN(new Date(this.state.PMS?.SyncDateTimeUTC).getTime())
                      ? new Intl.DateTimeFormat("en-US", {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                        hour: "numeric",
                        minute: "numeric",
                      }).format(new Date(this.state.PMS?.SyncDateTimeUTC))
                      : ""
                  }
                />
              </MDBCol>
            </MDBRow>
          </>
        ) : (
          ""
        )}
          
        {showTransactions ? (
         <>
          <MDBRow>
           <MDBCol sm="12" lg="6">
            <label htmlFor="defaultFormLoginEmailEx" className="black-text">
             Service Plan
            </label>
            <SelectSearch
             disabled={this.state.isModifyingSubscription}
             id="selectServicePlan"
             search={true}
             filterOptions={fuzzySearch}
             options={this.state.optionTemplateServicePlan}
             onChange={this.handleSelectChangeServicePlan}
             isOptionSelected={true}
             inputId="servicePlanArray"
             classNamePrefix="service-plan-select form-control"
             value={this.state.selectedServicePlanIndex}
             placeholder="Select..."
            />
            {this.state.paymentFailed ? (
             <div className="mt-1" style={{ color: "#cc0000" }}>Service Plan is currently degraded to {currentServicePlanName}</div>
            ) : (
             ""
            )}
            <div className="invalid-feedback">Please provide a service plan.</div>
           </MDBCol>
           <MDBCol sm="12" lg="6">
            <label htmlFor="defaultFormLoginEmailEx" className="black-text">
             Service Plan Price
            </label>
            <input disabled id="floor" className="form-control" value={getSymbolFromCurrency(this.state.currencyCode) + this.state.selectedServicePlanPriceNumber} />
            <div className="invalid-feedback">Please provide a floor.</div>
           </MDBCol>
           {window.location.pathname === "/networkdashboard" ? (
            <>
             <MDBCol sm="12" lg="6">
              <label htmlFor="defaultFormLoginEmailEx" className="black-text">
               VLAN
              </label>
              <input disabled id="vlan" className="form-control" value={this.state.vlan} />
              <div className="invalid-feedback">Please provide a vlan.</div>
             </MDBCol>
            </>
           ) : (
            ""
           )}
           <MDBCol sm="12" lg="6" className="ml-auto">
            <label htmlFor="defaultFormLoginEmailEx" className="black-text">
             Venue Discount
            </label>
            <input disabled id="floor" className="form-control" value={this.state.venuePriceAdjustment} />
            <div className="invalid-feedback">Please provide a floor.</div>
           </MDBCol>
          </MDBRow>
          <MDBRow>
           <MDBCol sm="12" lg="6">
            <label htmlFor="defaultFormLoginEmailEx" className="black-text">
             {t("addnewresident.servicestart")}
            </label>
            <DateInput
             dateFormat="MM/DD/YYYY"
             name="dateStart"
             placeholder="MM/DD/YYYY"
             value={this.state.dateStart}
             iconPosition="left"
             onChange={this.handleChange}
             onBlur={() => this.validateDateOnBlur("dateStart")}
             onKeyDown={this.preventDateKeyboardInput}
             className="dateTimePicker"
             closable={true}
             disabled={this.state.isModifyingSubscription || new Date(this.state.dateStart).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0) || this.state.PMS?.SyncDateTimeUTC !== "" || this.state.subscriberManagedviaSSO === true ? true : false}
             minDate={new Date()}
            />
            <label
             for="serviceStart"
             className="black-text"
             style={{
              fontSize: "11px",
              position: "absolute",
              top: "62px",
              left: "15px",
             }}
            >
             {this.props.venueType === "HOTSPOT" ? "Local Policy can use their Wi-Fi password as of this date" : t("addnewresident.servicestartlabel")}
            </label>
           </MDBCol>
           <MDBCol col="6">
            <label htmlFor="defaultFormLoginEmailEx" className="black-text">
             Subscription Discount
            </label>
            <input
             disabled={this.state.isModifyingSubscription || (window.location.pathname === "/networkdashboard" ? false : true)}
             type="number"
             step="0.01"
             id="shoppingCartPriceAdjustment"
             className="form-control subscriptionDiscount"
             name="subscriptionDiscount"
             value={-Math.abs(this.state.subscriptionDiscount).toFixed(2)}
             onChange={this.changeHandlerSubscriptionDiscount}
            />
           </MDBCol>
          </MDBRow>
          <MDBRow className="mt-2">
           <MDBCol sm="12" lg="6">
            <label htmlFor="defaultFormLoginEmailEx" className="black-text">
             {t("addnewresident.serviceend")}
            </label>
            <div style={{ position: "relative" }}>
             <DateInput
              dateFormat="MM/DD/YYYY"
              name="dateEnd"
              placeholder="MM/DD/YYYY"
              initialDate={this.state.dateEnd ? new Date(this.state.dateEnd) : new Date()}
              value={this.state.dateEnd}
              iconPosition="left"
              onChange={this.handleChange}
              onBlur={() => this.validateDateOnBlur("dateEnd")}
              onKeyDown={this.preventDateKeyboardInput}
              className="dateTimePicker"
              closable={true}
              minDate={new Date()}
              disabled={this.state.isModifyingSubscription || this.state.PMS?.SyncDateTimeUTC !== "" || this.state.subscriberManagedviaSSO === true ? true : false}
             />
             {this.state.dateEnd &&
              !(this.state.isModifyingSubscription || this.state.PMS?.SyncDateTimeUTC !== "" || this.state.subscriberManagedviaSSO === true) ? (
               <MDBIcon
                icon="times"
                onClick={() =>
                 this.setState({ dateEnd: "", invalidDateEnd: null })
                }
                title="Clear date"
                style={{
                 position: "absolute",
                 top: "11px",
                 right: "12px",
                 cursor: "pointer",
                 color: "#999",
                 zIndex: 2,
                }}
               />
              ) : (
               ""
              )}
            </div>
            <label
             className="black-text"
             style={{
              fontSize: "11px",
              position: "absolute",
              top: "62px",
              left: "15px",
             }}
            >
             {t("addnewresident.serviceendlabel")}
            </label>
           </MDBCol>
           <MDBCol sm="12" lg="3">
            <label htmlFor="defaultFormLoginEmailEx" className="black-text">
             Net Billing Price
            </label>
            <input disabled id="RealPageUnitID" className="form-control" value={this.state.netBillingPrice > 0 ? getSymbolFromCurrency(this.state.currencyCode) + this.state.netBillingPrice : getSymbolFromCurrency(this.state.currencyCode) + "0.00"} />
           </MDBCol>
           <MDBCol sm="12" lg="3">
            <label htmlFor="defaultFormLoginEmailEx" className="black-text">
             Payment Update Required?
            </label>
            <input disabled id="paymentFailed" className={this.state.paymentFailed ? "required form-control" : "notRequired form-control"} value={this.state.paymentFailed ? "Yes" : "No"} />
           </MDBCol>
          </MDBRow>
         </>
        ) : (
         <>
          <MDBRow>
           <MDBCol sm="12" lg="6">
            <label htmlFor="defaultFormLoginEmailEx" className="black-text">
             Service Plan
            </label>
            <SelectSearch
             id="selectServicePlan"
             search={true}
             filterOptions={fuzzySearch}
             options={this.state.optionTemplateServicePlan}
             onChange={this.handleSelectChangeServicePlan}
             isOptionSelected={true}
             inputId="servicePlanArray"
             classNamePrefix="service-plan-select form-control"
             value={this.state.selectedServicePlanIndex}
             placeholder="Select..."
            />
            <div className="invalid-feedback">Please provide a service plan.</div>
           </MDBCol>
          </MDBRow>
          <MDBRow>
           <MDBCol sm="12" lg="6">
            <label htmlFor="defaultFormLoginEmailEx" className="black-text">
             {t("addnewresident.servicestart")}
            </label>
            <DateInput
             dateFormat="MM/DD/YYYY"
             name="dateStart"
             placeholder="MM/DD/YYYY"
             value={this.state.dateStart}
             iconPosition="left"
             onChange={this.handleChange}
             className="dateTimePicker"
             disabled={new Date(this.state.dateStart) < new Date() || this.state.PMS?.SyncDateTimeUTC !== "" || this.state.subscriberManagedviaSSO === true ? true : false}
             readOnly
            />
            <label
             for="serviceStart"
             className="black-text"
             style={{
              fontSize: "11px",
              position: "absolute",
              top: "62px",
              left: "15px",
             }}
            >
             {this.props.venueType === "HOTSPOT" ? "Local Policy can use their Wi-Fi password as of this date" : t("addnewresident.servicestartlabel")}
            </label>
           </MDBCol>
           <MDBCol sm="12" lg="6">
            <label htmlFor="defaultFormLoginEmailEx" className="black-text">
             {t("addnewresident.serviceend")}
            </label>
            <div style={{ position: "relative" }}>
             <DateInput
              dateFormat="MM/DD/YYYY"
              name="dateEnd"
              placeholder="MM/DD/YYYY"
              initialDate={this.state.dateStart ? new Date(this.state.dateStart) : null}
              value={this.state.dateEnd}
              iconPosition="left"
              onChange={this.handleChange}
              onBlur={() => this.validateDateOnBlur("dateEnd")}
              className="dateTimePicker"
              minDate={this.state.dateStart ? new Date(this.state.dateStart) : null}
              disabled={this.state.PMS?.SyncDateTimeUTC !== "" || this.state.subscriberManagedviaSSO === true ? true : false}
             />
             {this.state.dateEnd &&
              !(this.state.PMS?.SyncDateTimeUTC !== "" || this.state.subscriberManagedviaSSO === true) ? (
               <MDBIcon
                icon="times"
                onClick={() =>
                 this.setState({ dateEnd: "", invalidDateEnd: null })
                }
                title="Clear date"
                style={{
                 position: "absolute",
                 top: "11px",
                 right: "12px",
                 transform: "translateY(-50%)",
                 cursor: "pointer",
                 color: "#999",
                 zIndex: 2,
                }}
               />
              ) : (
               ""
              )}
            </div>
            <label
             className="black-text"
             style={{
              fontSize: "11px",
              position: "absolute",
              top: "62px",
              left: "15px",
             }}
            >
             {t("addnewresident.serviceendlabel")}
            </label>
           </MDBCol>
          </MDBRow>
         </>
        )}
        <MDBRow>
         <MDBCol>
          {/* <MDBInput disabled={this.state.isModifyingSubscription} label="Allow account notifications via SMS" type="checkbox" id="contactpref_sms" name="contactpref_sms" onChange={this.toggleCheckboxValueSMS} checked={this.state.contactpref_sms} /> */}
          {/* <MDBInput
											label="Send notification via email"
											type="checkbox"
											id="contactpref_email"
											name="contactpref_email"
											onChange={this.toggleCheckboxValueEmail}
											checked={this.state.contactpref_email}
										/> */}
         </MDBCol>
        </MDBRow>
        <div className="text-right submitButton" style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-end', gap: '10px', alignItems: 'center'}}>
         <MDBBtn color="danger" onClick={this.toggleConfirmDeletion} disabled={this.state.isModifyingSubscription || this.state.subscriberManagedviaSSO !== false || (this.state.PMS?.SyncDateTimeUTC !== "" && this.props.isVenuePMSConfigured === true) ? true : false}  style={{width: 'auto', marginBottom: '0'}}>
          {this.props.loadingDelete === true ? (
           <div className="spinner-border spinner-border-sm" role="status">
            <span className="sr-only">Loading...</span>
           </div>
          ) : (
           "Delete Subscription"
          )}
         </MDBBtn>
        <MDBDropdown style={{ marginBottom: '0', display: 'inline-flex', flexWrap: 'nowrap', alignItems: 'stretch' }}>
          <MDBDropdownToggle
           color="danger"
           disabled={this.state.isModifyingSubscription}
           style={{
            width: 'auto',
            height: '39.5px',
            marginBottom: '0',
            paddingTop: '0.83rem',
            paddingBottom: '0.83rem',
            paddingLeft: '1.6rem',
            paddingRight: '1.6rem',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            whiteSpace: 'nowrap',
            lineHeight: '1.5',
            marginRight: '0.5px',
           }}
          >
           ACTIONS
          </MDBDropdownToggle>
          <MDBDropdownToggle
           split
           caret
           color="danger"
           disabled={this.state.isModifyingSubscription}
           className="dropdown-toggle-white-caret"
           style={{
            width: '39px',
            height: '39.5px',
            marginBottom: '0',
            marginLeft: '0px',
            padding: '0',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            lineHeight: '1.5',
           }}
          />
          
          <MDBDropdownMenu right>
           {(sessionStorage.getItem("stripeClientSecretSubscriber").length !== 0 || sessionStorage.getItem("stripeClientSecretSubscriber") !== "undefined") && parseFloat(this.state.netBillingPrice) !== 0 ? (
            <MDBDropdownItem href={"/update/checkout?ui=" + window.location.pathname.slice(1)} style={{ color: '#000' }}>
             <MDBIcon icon="credit-card" className="mr-2" style={{ color: '#000' }} />
             Modify Billing CC
            </MDBDropdownItem>
           ) : null}
           <MDBDropdownItem onClick={this.toggleResendActivation}>
            <MDBIcon icon="paper-plane" className="mr-2" />
            Resend Activation
           </MDBDropdownItem>
           <MDBDropdownItem onClick={this.toggleMoveVenue}>
            <MDBIcon icon="exchange-alt" className="mr-2" />
            Move to Another Venue
           </MDBDropdownItem>
          </MDBDropdownMenu>
         </MDBDropdown>
         <style>{`
          .dropdown-toggle-white-caret::after {
           border-top-color: #fff !important;
           border-width: 0.5em 0.5em 0 0.5em !important;
          }
         `}</style>
         {/* <MDBBtn color="info" onClick={this.checkValidationRequirements}>
                                        Check Requirements
                                    </MDBBtn> */}
         <MDBBtn color="danger" onClick={() => this.handleSaveChanges(false)} disabled={this.state.isModifyingSubscription} style={{width: 'auto', marginBottom: '0'}}>
          {this.props.loading === true || this.state.isModifyingSubscription ? (
           <div className="spinner-border spinner-border-sm" role="status">
            <span className="sr-only">Loading...</span>
           </div>
          ) : this.props.venueType === "HOTSPOT" ? (
           "Save Changes"
          ) : (
           t("modifyresident.modifyresident")
          )}
         </MDBBtn>
        </div>
       </form>
      </MDBTabPane>
      <MDBTabPane tabId="2" role="tabpanel">
       {this.state.messages !== undefined ? (
        this.state.loadingMessages === true ? (
         <div className="spinner-border spinner-border-sm" role="status">
          <span className="sr-only">Loading...</span>
         </div>
        ) : (
         <>
          <MDBRow>
           <MDBCol col="6">
            <div className="envelopeIcon" onClick={this.toggleMessageSend}>
             <MDBIcon icon="envelope" />
             <span>Send Message</span>
            </div>
           </MDBCol>
          </MDBRow>
          <MessagesData messages={this.state.messages} toggleMessage={this.toggleMessage} />
         </>
        )
       ) : (
        <div className="spinner-border spinner-border-sm" role="status">
         <span className="sr-only">Loading...</span>
        </div>
       )}
      </MDBTabPane>
      <MDBTabPane tabId="3" role="tabpanel">
       <Bandwidth venueID={this.props.venueID} unitID_internal={this.props.unitID_internal} email={this.state.email} />
      </MDBTabPane>
      <MDBTabPane tabId="4" role="tabpanel">
       {this.state.subscriberKeys !== undefined ? (
        this.state.loadingKeys === true ? (
         <div className="spinner-border spinner-border-sm" role="status">
          <span className="sr-only">Loading...</span>
         </div>
        ) : (
         <>
          Subscriber Token: <p id="password">{this.state.subscriberToken}</p>
          <div className="expandCollapsePasswords">
           <p
            onClick={() =>
             this.setState({ active: !this.state.active })
            }
           >
            {this.state.active
             ? <MDBBtn color="danger">Show Unit Keys</MDBBtn>
             : <MDBBtn color="danger">View All Keys</MDBBtn>
            }
           </p>
          </div>
          <div className="allrecentresidentsExpanded">
           {this.state.active ? (
            <SubscriberKeypoolsDataAllPasswords
             venueID={this.props.venueID}
             subscriberKeys={this.state.subscriberKeys}
             toggleConfirmRemoveKey={this.toggleConfirmRemoveKey}
             removeKeyConfirm={this.removeKeyConfirm}
             openChangeWifiPassword={this.openChangeWifiPassword}
             toggleShowWifiPassword={this.toggleShowWifiPassword}
             togglePSKValidator={this.togglePSKValidator}
             toggleGenerateWifiHandout={this.toggleGenerateWifiHandout}
            />
           ) : (
            <SubscriberKeypoolsData
             venueID={this.props.venueID}
             subscriberKeys={this.state.subscriberKeys}
             toggleConfirmRemoveKey={this.toggleConfirmRemoveKey}
             removeKeyConfirm={this.removeKeyConfirm}
             openChangeWifiPassword={this.openChangeWifiPassword}
             toggleShowWifiPassword={this.toggleShowWifiPassword}
             togglePSKValidator={this.togglePSKValidator}
             toggleGenerateWifiHandout={this.toggleGenerateWifiHandout}
            />
           )}
           <div className="text-right submitButton">
            <MDBBtn color="danger" onClick={this.toggleAddKey}>
             Add Key
            </MDBBtn>
           </div>
          </div>
         </>
        )
       ) : (
        <div className="spinner-border spinner-border-sm" role="status">
         <span className="sr-only">Loading...</span>
        </div>
       )}
      </MDBTabPane>
      <MDBTabPane tabId="5" role="tabpanel">
       {this.state.transactions !== undefined ? (
        <>
         <div className="allrecentresidentsExpanded">
          <SubscriberTransactionsData transactions={this.state.transactions} stripeClientParentSecret={this.state.stripeClientParentSecret} toggleRefund={this.toggleRefund} />
         </div>
        </>
       ) : (
        <div className="spinner-border spinner-border-sm" role="status">
         <span className="sr-only">Loading...</span>
        </div>
       )}
      </MDBTabPane>
      <MDBTabPane tabId="6" role="tabpanel">
       <LogViewer
        logType="subscriber"
        subscriberToken={this.state.subscriberToken}
       />
      </MDBTabPane>
      <MDBTabPane tabId="7" role="tabpanel">
       {this.state.devices !== undefined ? (
        <>
         <ManageDevicesData deviceData={this.state.devices} />
        </>
       ) : (
        <div className="spinner-border spinner-border-sm" role="status">
         <span className="sr-only">Loading...</span>
        </div>
       )}
      </MDBTabPane>
      <MDBTabPane tabId="8" role="tabpanel">
       <div>
        <h4>System Data</h4>
        <MDBRow>
         <MDBCol col="12" sm="12" lg="6">
          <label htmlFor="defaultFormLoginEmailEx" className="black-text">
           Cognito Status
          </label>
          <input disabled id="cognitoStatus" name="cognitoStatus" className="form-control" value={this.state.cognitoStatus} />
         </MDBCol>
         <MDBCol col="12" sm="12" lg="6">
          <label htmlFor="defaultFormLoginEmailEx" className="black-text">
           Status
          </label>
          <input disabled id="status" name="status" className="form-control" value={this.state.status} />
         </MDBCol>
        </MDBRow>
        <br />
        <MDBRow>
         <MDBCol col="12" sm="12" lg="6">
          <label htmlFor="defaultFormLoginEmailEx" className="black-text">
           Email Verified
          </label>
          <input disabled id="emailVerified" name="emailVerified" className="form-control" value={this.state.emailVerified} />
         </MDBCol>
         <MDBCol col="12" sm="12" lg="6">
          <label htmlFor="defaultFormLoginEmailEx" className="black-text">
           Subscriber Token <MDBIcon icon="copy" onClick={this.copySubscriberToken} />
          </label>
          <input disabled id="subscriberToken" name="subscriberToken" className="form-control" value={this.state.subscriberToken} />
          <span id="subscriberTokenHidden">{this.state.subscriberToken}</span>
         </MDBCol>
        </MDBRow>
        <br />
        <MDBRow>
         <MDBCol col="12" sm="12" lg="6">
          <label htmlFor="defaultFormLoginEmailEx" className="black-text">
           Phone Number Verified
          </label>
          <input disabled id="phoneVerified" name="phoneVerified" className="form-control" value={this.state.phoneVerified} />
         </MDBCol>
         <MDBCol col="12" sm="12" lg="6">
          <label htmlFor="defaultFormLoginEmailEx" className="black-text">
           External Subscriber ID <MDBIcon icon="copy" onClick={this.copyExternalSubscriberID} />
          </label>
          <input disabled id="externalSubscriberID" name="externalSubscriberID" className="form-control" value={this.state.externalSubscriberID} />
          <span id="externalSubscriberIDHidden">{this.state.externalSubscriberID}</span>
         </MDBCol>
        </MDBRow>
        <br />
        <MDBRow>
         <MDBCol col="12" sm="12" lg="6">
          <label htmlFor="defaultFormLoginEmailEx" className="black-text">
           Stripe Customer ID <MDBIcon icon="copy" onClick={this.copyStripeCustomerID} />
          </label>
          <input disabled id="stripeCustomerID" name="stripeCustomerID" className="form-control" value={this.state.stripeCustomerID} />
          <span id="stripeCustomerIDHidden">{this.state.stripeCustomerID}</span>
         </MDBCol>
         <MDBCol col="12" sm="12" lg="6">
          <label htmlFor="defaultFormLoginEmailEx" className="black-text">
           Subscriber Managed by SSO
          </label>
          <input disabled id="managedBySSO" name="managedBySSO" className="form-control" value={this.state.subscriberManagedviaSSO} />
         </MDBCol>
        </MDBRow>
        <br />
        <MDBRow>
         <MDBCol col="12" sm="12" lg="6">
          <label htmlFor="defaultFormLoginEmailEx" className="black-text">
           Contact Pref SMS
          </label>
          <input disabled id="contactpref_sms" name="contactpref_sms" className="form-control" value={this.state.contactpref_sms} />
         </MDBCol>
         <MDBCol col="12" sm="12" lg="6">
          <label htmlFor="defaultFormLoginEmailEx" className="black-text">
           Contact Pref Email
          </label>
          <input disabled id="contactpref_email" name="contactpref_email" className="form-control" value={this.state.contactpref_email} />
         </MDBCol>
        </MDBRow>
        <br />
        <MDBRow>
         <MDBCol col="12" sm="12" lg="12">
          <label htmlFor="defaultFormLoginEmailEx" className="black-text">
           Date Added
          </label>
          <input disabled id="dateAdded" name="dateAdded" className="form-control" value={this.state.dateAdded} />
         </MDBCol>
        </MDBRow>        
        {this.state.PMS?.EntrataUnitSpaceID && (
         <>
          <br />
          <MDBRow>
           <MDBCol col="12" sm="12" lg="6">
            <label htmlFor="defaultFormLoginEmailEx" className="black-text">
             Entrata Lease ID
            </label>
            <input disabled id="entrataLeaseID" name="entrataLeaseID" className="form-control" value={this.state.PMS?.EntrataLeaseID} />
           </MDBCol>
           <MDBCol col="12" sm="12" lg="6">
            <label htmlFor="defaultFormLoginEmailEx" className="black-text">
             Entrata Customer ID
            </label>
            <input disabled id="entrataCustomerID" name="entrataCustomerID" className="form-control" value={this.state.PMS?.EntrataCustomerID} />
           </MDBCol>
          </MDBRow>
         </>
        )}
        {this.state.PMS?.RealPageUnitID && (
         <>
          <br />
          <MDBRow>
           <MDBCol col="12" sm="12" lg="12">
            <label htmlFor="defaultFormLoginEmailEx" className="black-text">
             RealPage Lease ID
            </label>
            <input disabled id="realPageLeaseID" name="realPageLeaseID" className="form-control" value={this.state.PMS?.RealPageLeaseID} />
           </MDBCol>
          </MDBRow>
         </>
        )}
        
       </div>
      </MDBTabPane>
     </MDBTabContent>
    </MDBModalBody>
   </>
  );
 }
}
export default withTranslation()(ModifyResident);
